/*
 * dfx-pdp.js 0926.1 - the ONE product-page module (pdp-component-0926/DESIGN.md rev4).
 * Loaded with defer by snippets/dfx-pdp.liquid on every product page (the only variant UI since phase B).
 *
 * Consumes: island script#dfx-pdp-data-{sid} (v 1) rendered just before its root
 *   .dfx-pdp[data-dfx-pdp][data-section][data-mode][data-picker][data-caller][data-dfx-pdp-js];
 *   triggers [data-dfx-open=pill|sticky|color]; the festive block / compact picker / hamper dialog hooks;
 *   [id=custom_line_property] [id=addition_line_property] [id=festive_line_property] divs in the cart forms;
 *   Dawn product-info (pendingRequestUrl, productForm, updateURL) and pubsub; DfxOfferUnlock.syncStripState.
 * Exposes: window.DfxPdp (frozen, + __pure), window.showBottomSheet(), window.airboostMobStickyAtc(e, btn),
 *   window.dfxFestiveBuyNowItems(form, id, qty); document CustomEvents dfx:pdp-open|cancel|confirm|applied|
 *   landing-timeout|link-nav|island-mismatch|legacy-global-read|asset-mismatch, dfx:festive-offer,
 *   dfx:hamper-open; hidden inputs properties[_festive|_festive_code|_hamper], the 7 custom-size
 *   properties and Length/Width/Height; window.productVariants as a counting getter (J1-1).
 * House rules: classic ES2017 script, no jQuery, no MutationObserver, no setInterval. The only
 *   dataLayer push is dfx_size_memory_applied; the GA4 names go through DFXThemeTrack behind flags.ga4.
 */
(function () {
  if (window.__dfx_pdp_booted) return;
  window.__dfx_pdp_booted = true;

  var VERSION = '0926.1';
  var ISLAND_V = 1;
  var W = window;
  var D = document;
  // Only readable while this file executes; used for the CDN fingerprint check (P-12).
  var SRC = (D.currentScript && D.currentScript.src) || '';
  var CUSTOM_RE = /custom|matns/i;
  var ID_INPUTS = 'form[action*="/cart/add"] input[name="id"]';
  var INACTIVE_MS = 30 * 60 * 1000;
  var instances = new Map();

  /* ---------------------------------------------------------------- helpers */
  function arr(x) { return Array.prototype.slice.call(x || []); }
  function $(s, c) { return (c || D).querySelector(s); }
  function $$(s, c) { return arr((c || D).querySelectorAll(s)); }
  // Writers address duplicated ids through [id=..] exactly like the theme always did.
  function ids(id, c) { return $$('[id="' + id + '"]', c); }
  function str(v) { return v == null ? '' : String(v).trim(); }
  function has(o, k) { return !!o && Object.prototype.hasOwnProperty.call(o, k); }
  function copy(o) { return o == null ? o : JSON.parse(JSON.stringify(o)); }
  // Every write is skipped when nothing changes: GoKwik, Clarity and theme scripts run body-wide
  // MutationObservers, so an idle write is not free (J1-6 / J3-2).
  function setText(el, t) { t = t == null ? '' : String(t); if (el && el.textContent.trim() !== t) el.textContent = t; }
  function setHTML(el, h) { h = h == null ? '' : String(h); if (el && el.__dfxH !== h) { el.innerHTML = h; el.__dfxH = h; } }
  function tog(el, c, on) { if (el && el.classList.contains(c) !== !!on) el.classList.toggle(c, !!on); }
  function hideEl(el, on) { if (el && el.hidden !== !!on) el.hidden = !!on; }
  function setAttr(el, a, v) {
    if (!el) return;
    if (v == null) { if (el.hasAttribute(a)) el.removeAttribute(a); } else if (el.getAttribute(a) !== String(v)) el.setAttribute(a, v);
  }
  function emit(name, detail) { try { D.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: false })); } catch (e) {} }
  function sget(k) { try { return W.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { W.sessionStorage.setItem(k, v); } catch (e) {} }
  // Our own synthetic changes are tagged so the staging swallow and the landing detector skip them.
  function fire(el) { var e = new Event('change', { bubbles: true }); e.__dfxApply = true; el.dispatchEvent(e); }
  function warn(m, x) { try { W.console.warn('[dfx-pdp] ' + m, x || ''); } catch (e) {} }

  /* ================================================================ Island */
  var Island = {
    // dfx-pdp.liquid prints the island right before its root, never inside it.
    el: function (root, sid) {
      var p = root.parentNode;
      return (p && $('script[id="dfx-pdp-data-' + sid + '"]', p)) || D.getElementById('dfx-pdp-data-' + sid);
    },
    read: function (el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } },
    ok: function (d) { return !!(d && d.v === ISLAND_V && d.sid); },
    // Lookup tables are built once; the island itself is never written back (D-2.3).
    index: function (d) {
      if (d.__ix) return d;
      d.__ix = 1;
      d.options = d.options || []; d.values = d.values || []; d.variants = d.variants || [];
      d.strings = d.strings || {}; d.flags = d.flags || {}; d.links = d.links || []; d.nodes = d.nodes || [];
      var slot = {}, vidx = {}, byId = {}, byO = {};
      // m4: memory/labels use only options whose island slot is set (null = ignored).
      d.options.forEach(function (op, k) { if (op && op.slot && !has(slot, op.slot)) slot[op.slot] = k; });
      d.values.forEach(function (vals, k) { (vals || []).forEach(function (x, i) { vidx[String(x.id)] = [k, i]; }); });
      d.variants.forEach(function (v) {
        v.o = v.o || [];
        byId[String(v.id)] = v;
        byO[v.o.join(',')] = v;
        v._dl = has(v, 'dl') ? v.dl : d.dl; // the island hoists the locked strip text (per-variant dl, else the top-level one)
      });
      d.slot = slot; d.vidx = vidx; d.byId = byId; d.byO = byO;
      d.dk = has(slot, 'dimension') ? slot.dimension : -1;
      d.hk = has(slot, 'height') ? slot.height : -1;
      return d;
    },
    // R2: every ?section_id render carries a fresh island; server-newer values win in place.
    refresh: function (d, doc) {
      var el = doc && doc.querySelector && doc.querySelector('script[id^="dfx-pdp-data-"]');
      var f = el && Island.read(el);
      // Only this product's render may refresh it (a quick-add can share the section id).
      if (!Island.ok(f) || (f.product && d.product && f.product.id !== d.product.id)) return;
      (f.variants || []).forEach(function (n) {
        var v = d.byId[String(n.id)];
        if (!v) return;
        ['a', 'p', 'c', 'pm', 'cm', 'pctInt', 'pctRound', 'd', 'p5', 'pm5', 'pct5'].forEach(function (k) { if (has(n, k)) v[k] = n[k]; });
        v._dl = has(n, 'dl') ? n.dl : f.dl;
      });
      d.selected = f.selected;
    },
    // theme.liquid:2025-2039 shape, served only through the counting getter (J1-1).
    legacy: function (d) {
      idx(d);
      return d.variants.map(function (v) {
        var vals = v.o.map(function (i, k) { return d.values[k][i].v; });
        var g = v.g || [];
        return {
          id: v.id, price: v.p, compare_at_price: v.cm === '' ? null : v.c,
          title: vals.length ? vals.join(' / ') : 'Default Title',
          option1: vals.length ? vals[0] : 'Default Title', option2: vals[1] == null ? null : vals[1], option3: vals[2] == null ? null : vals[2],
          gokwik_length: g[0] == null ? null : g[0], gokwik_width: g[1] == null ? null : g[1], gokwik_height: g[2] == null ? null : g[2]
        };
      });
    }
  };
  function idx(d) { return Island.index(d); }

  /* ================================================================ Money */
  // theme.liquid:2014-2021 verbatim (J1-3). Used for Custom-size quotes ONLY: every standard price,
  // plain or Festive5, is a Liquid string from the island so no surface flips format (C2-G5).
  function convert_rupees(number){
      var currency_number = number.toLocaleString('en-IN', {
         maximumFractionDigits: 2,
         style: 'currency',
         currency: 'INR'
      });
      return currency_number;
    }

  /* ================================================================ Resolve */
  // Former size-memory build (478 lines) L69-73 verbatim: "72 x 36" == "72x36", "6 (15.2cm)" == "6 (15.2 cm)".
  function norm(v) {
    return String(v == null ? '' : v)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '');
  }
  function sizeVal(d, i) { var x = d.values[0] && d.values[0][i]; return x ? x.v : ''; }
  function isCustIdx(d, i) { return CUSTOM_RE.test(sizeVal(d, i)); }
  function isCustV(d, v) { return !!v && v.o.length > 0 && isCustIdx(d, v.o[0]); }
  function fits(v, o, k, skip) {
    for (var j = 0; j < k; j++) if (j !== skip && v.o[j] !== o[j]) return false;
    return true;
  }
  // J1-2 rule: value i of option k is available iff some AVAILABLE variant matches the earlier
  // staged options plus i (k = 0: any available variant of that Size) - Liquid's value.available.
  function available(d, o, k, i, skip) {
    idx(d);
    if (skip == null) skip = -1;
    return d.variants.some(function (v) { return !!v.a && v.o[k] === i && fits(v, o, k, skip); });
  }
  function firstAvail(d, o, k, skip) {
    var n = (d.values[k] || []).length;
    for (var i = 0; i < n; i++) if (available(d, o, k, i, skip)) return i;
    return null;
  }
  // skip = the dimension slot under a Custom size: the Custom variant is found by Size + Height.
  function exact(d, o, skip) {
    idx(d);
    if (skip == null || skip < 0) return d.byO[o.join(',')] || null;
    var hit = null;
    d.variants.some(function (v) {
      if (v.o.length !== o.length || !fits(v, o, o.length, skip)) return false;
      if (!hit) hit = v;
      if (v.a) { hit = v; return true; }
      return false;
    });
    return hit;
  }
  // D-4.3: visible and deterministic. The size slot (position 0) is never moved; a later option
  // that is unavailable under the earlier ones moves to the first available value (kept when none
  // is, e.g. a sold-out Size). m18: under Custom the dimension slot is skipped and the shopper's
  // pre-Custom dimension comes back when the Size leaves Custom.
  function settle(d, s) {
    idx(d);
    var o = s.o, dk = d.dk, cust = isCustIdx(d, o[0]);
    if (cust && !s.inC) { s.inC = true; s.dimSave = dk >= 0 ? o[dk] : null; }
    else if (!cust && s.inC) { s.inC = false; if (dk >= 0 && s.dimSave != null) o[dk] = s.dimSave; s.dimSave = null; }
    var skip = cust ? dk : -1;
    for (var k = 1; k < o.length; k++) {
      if (k === skip) continue;
      if (!available(d, o, k, o[k], skip)) {
        var f = firstAvail(d, o, k, skip);
        if (f != null) o[k] = f;
      }
    }
    var v = exact(d, o, skip);
    // The dimension fieldset is hidden under Custom; keeping its radio on the Custom variant's own
    // value makes Dawn's option_values request exact (dimSave still restores the shopper's pick).
    if (v && skip >= 0) o[skip] = v.o[skip];
    return v;
  }

  /* ================================================================ Links */
  // Links mode (D-4.5, links-combo-fix 0926): the popup stages ONE value per link group (s.lv) and
  // resolves the product whose own names (island nodes[].k) equal ALL of them. Values compare
  // through norm(), so "3 Seater" == "3-seater". Pure: the unit harness drives these directly.
  function lkEq(a, b) { return a != null && b != null && norm(a) === norm(b); }
  function lkFits(n, keys, lv, skip) {
    for (var j = 0; j < keys.length; j++) if (keys[j] !== skip && !lkEq(n.k && n.k[keys[j]], lv[keys[j]])) return false;
    return true;
  }
  // L = {keys (group order), nodes, cur (this product's node), shown {key: [norm(value) printed in the popup]}},
  // or null when the island carries no node table (picker mode, or a product without a node row).
  function linkView(d) {
    idx(d);
    if (has(d, '__lk')) return d.__lk;
    var keys = d.links.map(function (g) { return g.key; }), cur = null, shown = {}, h = d.product && d.product.handle;
    d.nodes.some(function (n) { if (n && n.k && n.h === h) { cur = n; return true; } return false; });
    d.links.forEach(function (g) { shown[g.key] = [g.cur].concat((g.items || []).map(function (i) { return i.t; })).map(norm); });
    d.__lk = cur && keys.length ? { keys: keys, nodes: d.nodes.filter(function (n) { return n && n.k; }), cur: cur, shown: shown } : null;
    return d.__lk;
  }
  // When the exact combination does not exist, the OTHER staged values are kept in this order:
  // Seating Capacity first (Mayank 2026-09-26), then Color, then the rest in group order.
  function lkOrder(keys, g) {
    var o = [];
    ['seating', 'color'].forEach(function (k) { if (k !== g && keys.indexOf(k) >= 0) o.push(k); });
    keys.forEach(function (k) { if (k !== g && o.indexOf(k) < 0) o.push(k); });
    return o;
  }
  function lkBetter(a, b) {
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return a[i] > b[i];
    return false; // a tie keeps the earlier node (hop 1 before hop 2)
  }
  // lv = the staged values (null = this product's own); g/val = the tapped group and value (g null = none).
  // -> {lv: the values to show, node: the target node (L.cur = no navigation) | null, exact}
  function linkResolve(L, lv, g, val) {
    var keys = L.keys, next = {};
    keys.forEach(function (k) { next[k] = lv && lv[k] != null ? lv[k] : L.cur.k[k]; });
    if (g != null && keys.indexOf(g) >= 0) next[g] = val;
    var hit = lkFits(L.cur, keys, next) ? L.cur : null;
    if (!hit) {
      L.nodes.some(function (n) {
        if (!lkFits(n, keys, next)) return false;
        if (!hit) hit = n;
        if (n.a) { hit = n; return true; }
        return false;
      });
    }
    if (hit || g == null) return { lv: next, node: hit, exact: !!hit };
    // Missing combination: keep the tapped value, then as many other staged values as possible by
    // priority [seating, color], then by count, then group order; a product whose values the popup
    // can show beats one it cannot, an available one beats a sold-out one.
    var order = lkOrder(keys, g), pri = order.filter(function (k) { return k === 'seating' || k === 'color'; });
    var rest = order.filter(function (k) { return pri.indexOf(k) < 0; }), best = null, bs = null;
    L.nodes.forEach(function (n) {
      if (!lkEq(n.k[g], val)) return;
      var m = function (k) { return lkEq(n.k[k], next[k]) ? 1 : 0; };
      var shown = keys.every(function (k) { return n.k[k] != null && (L.shown[k] || []).indexOf(norm(n.k[k])) >= 0; }) ? 1 : 0;
      var sc = pri.map(m).concat([rest.filter(m).length], rest.map(m), [shown, n.a ? 1 : 0]);
      if (!bs || lkBetter(sc, bs)) { best = n; bs = sc; }
    });
    if (!best) return { lv: next, node: null, exact: false };
    var real = {};
    keys.forEach(function (k) { real[k] = best.k[k]; });
    return { lv: real, node: best, exact: false };
  }
  // Can value val of group g combine with the OTHER staged values? (else it is shown struck through)
  function linkOpen(L, lv, g, val) {
    var probe = {};
    L.keys.forEach(function (k) { probe[k] = lv[k]; });
    probe[g] = val;
    return L.nodes.some(function (n) { return lkFits(n, L.keys, probe); });
  }
  // Shopify's amount styles ([thousands, decimal mark, no decimals]). The island's own pm / p pair
  // shows which one (and the currency text around it) this shop prints, so a node's paise read
  // exactly like price.liquid's `money` output; unknown -> convert_rupees.
  var AMT = [[',', '.', 0], ['.', ',', 0], ["'", '.', 0], [' ', ',', 0], [' ', '.', 0], [',', '', 1], ['.', '', 1], [' ', '', 1]];
  function amt(c, f) {
    c = Math.round(Math.abs(c));
    var g = function (n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, f[0]); };
    return f[2] ? g(Math.round(c / 100)) : g(Math.floor(c / 100)) + f[1] + String(100 + c % 100).slice(1);
  }
  function moneyLike(sp, st, c) {
    if (sp == null || !st || c == null) return null;
    st = String(st);
    for (var i = 0; i < AMT.length; i++) {
      var a = amt(sp, AMT[i]), at = st.indexOf(a);
      if (at >= 0 && !/\d/.test(st.charAt(at - 1) + st.charAt(at + a.length))) return st.slice(0, at) + amt(c, AMT[i]) + st.slice(at + a.length);
    }
    return null;
  }
  // The popup footer for a target node: price.liquid's pm / cm (commas -> spaces) / pctRound rules.
  function linkQuote(d, n) {
    if (!n || n.p == null) return null;
    idx(d);
    var v = d.byId[String(d.selected)] || d.variants[0];
    var m = function (x) { return moneyLike(v && v.p, v && v.pm, x) || convert_rupees(x / 100); };
    var c = n.c != null ? n.c : n.p;
    return { priceText: m(n.p), mrpText: n.c == null ? '' : m(n.c).replace(/,/g, ' '), chip: (c > 0 ? Math.round((c - n.p) * 100 / c) : 0) + '% off', d: n.d || null, dl: n.dl || '' };
  }

  /* ================================================================ CustomPrice */
  // theme.liquid:2104-2154 + 2189-2283 ported with PLAN Q8 (never a negative d_price: price from the
  // Custom variant) and Q9 (Height = gokwik_height of the pricing variant, else the number).
  function htNum(s) { return parseInt(String(s == null ? '' : s).split(' ')[0].replace(/\u201d/g, '').replace(/"/g, '')); }
  function parseHt(s) { return parseInt(String(s == null ? '' : s).split('(')[0].trim()); }
  function parseDim(s) {
    // U-6-23 fix: the multiplication sign is normalised BEFORE the non-digit strip ("72 \u00d7 36"
    // used to lose its width).
    var p = String(s == null ? '' : s).split('(')[0].trim().replace(/\u00d7/g, 'x')
      .replace(/[^\dxX ]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase().split('x');
    return { len: parseInt(p[0]), wt: parseInt(p[1]) };
  }
  function optVal(d, v, k) { return k >= 0 && d.values[k] && d.values[k][v.o[k]] ? d.values[k][v.o[k]].v : null; }
  function rate(a, i) { var r = a && i != null ? a[i] : null; return r == null || r === '' ? NaN : Number(r); }
  function customQuote(d, len, wid, hIdx, v) {
    idx(d);
    var c = d.custom || {}, bh = c.byHeight || {};
    len = parseInt(len); wid = parseInt(wid);
    var hv = d.hk >= 0 && hIdx != null && d.values[d.hk][hIdx] ? d.values[d.hk][hIdx].v : null;
    var ht = htNum(hv);
    var bid = hIdx != null && bh[hIdx] != null ? bh[hIdx] : bh['*'];
    var base = (bid != null && d.byId[String(bid)]) || v;
    var bp = base.p / 100, bc = base.c > 0 ? base.c / 100 : bp;
    var q = { len: len, wid: wid, base: base.id };
    var m = null;
    if (d.dk >= 0 && d.hk >= 0 && !isNaN(ht)) {
      // findMatchingVariant: same height, the nearest UPWARD size, length difference first.
      var ups = [];
      d.variants.forEach(function (x) {
        if (parseHt(optVal(d, x, d.hk)) !== ht) return;
        var dm = parseDim(optVal(d, x, d.dk));
        if (dm.len >= len && dm.wt >= wid) ups.push({ x: x, len: dm.len, wt: dm.wt });
      });
      ups.sort(function (a, b) {
        var al = a.len - len, bl = b.len - len;
        return al === bl ? (a.wt - wid) - (b.wt - wid) : al - bl;
      });
      m = ups.length ? ups[0].x : null;
    }
    if (m) {
      q.branch = 'A'; q.match = m.id;
      q.height = str(m.g && m.g[2]) || parseHt(optVal(d, m, d.hk));
      if (base.p < m.p) { q.price = bp; q.mrp = bc; q.d = 0; q.capped = true; } // PLAN Q8: PDP == cart
      else { q.price = m.p / 100; q.mrp = m.c > 0 ? m.c / 100 : q.price; q.d = (base.p - m.p) / 100 | 0; }
      q.pct = q.mrp ? Math.floor(((q.mrp - q.price) * 100) / q.mrp) : 0;
      return q;
    }
    q.height = str(base.g && base.g[2]) || ht;
    var sqft = len * wid * ht * 0.00694444;
    var rm = rate(c.mrp, hIdx), rs = rate(c.sell, hIdx);
    if (isNaN(sqft) || isNaN(rm) || isNaN(rs)) {
      // No rate (5th height, blank metafield, no height option): the Custom variant's own price,
      // still purchasable - never "Size not available" (J1-A-5, U-6-20/21/24).
      q.branch = 'F'; q.price = bp; q.mrp = bc; q.d = 0; q.pct = base.pctInt || 0;
      return q;
    }
    var mrp = Math.round(rm * sqft), selling = Math.floor(rs * sqft);
    // A Discount Function can only REDUCE a line price: cap the sq-ft price at the variant price.
    if (selling > bp) { selling = bp; if (mrp < selling) mrp = selling; }
    q.branch = 'B'; q.price = selling; q.mrp = mrp;
    q.pct = mrp ? parseInt((mrp - selling) * 100 / mrp) : 0;
    q.d = (bp - selling) | 0;
    return q;
  }

  /* ================================================================ Quote */
  function off5(p) { return Math.floor((p * 5 + 50) / 100); } // D-9.2 half-up in integer paise
  // D-5.1. *_paise fields are integers (pp/mp); *Text are Liquid strings for standard variants and
  // convert_rupees() for Custom quotes only.
  // Mayank 2026-10-01: what the page SHOWS follows the quantity - price, MRP, the hamper's worth and item counts (claim
  // bar, dropdown row, popup card) and the deal line. Strings only: pp / mp / q.h stay per unit (cart properties, the
  // Function and the gift lines are per unit x line quantity). moneyLike keeps Liquid's own money format; Custom quotes
  // are convert_rupees() as before.
  function qtyText(q, base) {
    if (q.qty < 2) return q;
    var m = function (t, c) { return !t ? t : (q.fmt === 'liquid' && moneyLike(c, t, c * q.qty)) || convert_rupees(c * q.qty / 100); };
    q.priceText = m(q.priceText, q.pp); q.mrpText = m(q.mrpText, q.mp); q.baseText = m(q.baseText, base);
    if (q.f5Text) q.f5Text = m(q.f5Text, q.p5);
    if (q.h) {
      // hd = the hamper as displayed: worth x qty, and the row copy "(1 Pillow, 1 Comforter)" -> "(2 Pillows, 2 Comforters)"
      var w = q.h.w * q.qty, wt = String(w).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      q.hd = copy(q.h); q.hd.w = w; q.hd.wt = wt;
      q.hd.row = q.h.row.replace(new RegExp(q.h.wt.replace(/,/g, ',?')), function (x) { return x.indexOf(',') < 0 ? String(w) : wt; })
        .replace(/\(([^)]*)\)\s*$/, function (x, s) { return '(' + s.replace(/(\d+)(\s+)([^,\d]*[^,\d\s])/g, function (y, n, sp, name) { return n * q.qty + sp + name + (/s$/i.test(name) ? '' : 's'); }) + ')'; });
      if (q.offer === 'hamper') q.note = q.note.split(q.h.wt).join(wt);
    }
    return q;
  }
  // The quote as the display writers read it: h = the displayed hamper (hd) when the quantity scaled it.
  function shown(q) {
    if (!q || !q.hd) return q;
    var s = Object.create(q);
    s.h = q.hd;
    return s;
  }
  // The deal line ("Get it as low as ₹22652 ...", HTML from the variant metafield): its first amount x qty, format kept.
  function dealQty(html, qty) {
    if (qty < 2 || !html) return html;
    return String(html).replace(/((?:&#8377;|₹|Rs\.?)\s*)(\d[\d,]*)/, function (x, cur, n) {
      var v = parseInt(n.replace(/,/g, '')) * qty;
      return cur + (n.indexOf(',') < 0 ? v : v.toLocaleString('en-IN'));
    });
  }
  // Mayank 2026-10-01: a Custom selection typed as a standard size (e.g. 72 x 30, same height and other options) IS
  // that standard variant - the standard SKU goes to the cart, never the Custom one. -> the selection to commit
  // (s itself when it is no such case, or that standard variant is sold out).
  // ponytail: applied where a commit dispatches (popup Confirm, memory, boot). The keyboard select bridge and the
  // passthrough / inline L x W inputs keep the Custom variant; move the swap to the cart forms if those must follow.
  function stdSel(d, s) {
    idx(d);
    var o = s && s.o, lw = s && (s.lw || { len: 72, wid: 30 }), hit = null;
    if (!o || d.dk < 0 || !isCustIdx(d, o[0])) return s;
    d.variants.some(function (x) {
      if (isCustV(d, x) || x.o.length !== o.length) return false;
      for (var k = 1; k < o.length; k++) if (k !== d.dk && x.o[k] !== o[k]) return false;
      var dm = parseDim(optVal(d, x, d.dk));
      if (dm.len !== lw.len || dm.wt !== lw.wid) return false;
      if (x.a) hit = x;
      return !!hit;
    });
    if (!hit) return s;
    var n = copy(s);
    n.o = hit.o.slice(); n.inC = false; n.dimSave = null;
    return n;
  }
  function quoteOf(d, sel, qty) {
    idx(d);
    qty = Math.max(1, parseInt(qty) || 1);
    sel = sel || {};
    // A selection is its option indexes; vid is only a fallback (a staged copy of `applied` still
    // carries the applied vid, which must never win over the staged options).
    var o = sel.o || [];
    var byO = Array.isArray(sel.o) && (o.length > 0 || !d.options.length);
    var v = byO || sel.vid == null ? exact(d, o, isCustIdx(d, o[0]) ? d.dk : -1) : d.byId[String(sel.vid)];
    var q = { v: v || null, qty: qty, offer: 'none', note: '', priceText: '', mrpText: '', chipPopup: '', chipBlock: '', chipCard: '' };
    if (!v) return q;
    var lw = sel.lw || { len: 72, wid: 30 };
    var cw = isCustV(d, v) ? lw : null;
    if (cw && d.custom) {
      var c = customQuote(d, cw.len, cw.wid, d.hk >= 0 ? v.o[d.hk] : null, v);
      q.cq = c; q.fmt = 'rupees';
      q.pp = Math.round(c.price * 100); q.mp = Math.round(c.mrp * 100);
      q.pInt = q.pRound = c.pct;
      q.priceText = convert_rupees(c.price); q.mrpText = convert_rupees(c.mrp);
    } else {
      q.fmt = 'liquid'; q.pp = v.p; q.mp = v.c; q.pInt = v.pctInt; q.pRound = v.pctRound;
      q.priceText = v.pm; q.mrpText = v.cm;
    }
    q.custom = q.cq ? cw : null;
    q.baseText = q.priceText;
    q.chipPopup = q.chipBlock = q.pRound + '% off';
    q.chipCard = q.pInt + '% off';
    if (!festOf(d)) return qtyText(q, q.pp);
    var base = q.pp;
    q.cls = cls(d, v);
    q.h = q.cls === 'none' ? null : hamperOf(d, v, cw);
    var inactive = festInactive();
    q.offer = effectiveOffer(d, sel.offer, q, inactive);
    var mp = q.mp || 1;
    // GoKwik's cart "% OFF" (Mayank 2026-10-16): (all MRPs - all selling prices) / all MRPs, the gifts counted at their
    // own MRP (compare_at, as GoKwik strikes them through) and at the ₹1 a unit the discount Function bills them.
    // A custom size's cart MRP is the Custom VARIANT's compare_at (v.c), not the computed size MRP shown on the PDP.
    var gkMrp = q.cq ? v.c : q.mp;
    if (q.h) q.hp = Math.round((gkMrp + q.h.gm - q.pp - q.h.gu * 100) / (gkMrp + q.h.gm) * 100);
    var p5 = q.pp - off5(q.pp);
    q.p5 = p5;
    q.f5Text = q.fmt === 'liquid' ? v.pm5 : convert_rupees(p5 / 100);
    q.f5Pct = q.fmt === 'liquid' ? v.pct5 : Math.round((1 - p5 / mp) * 100);
    if (q.offer === 'hamper') {
      q.chipPopup = q.hp + '% off incl. hamper'; // pin 5: popup footer / compact card
      q.chipBlock = q.hp + '% off';              // pin 5: price block chip (F-2)
      q.chipSub = 'with Free hamper';            // smaller text in the same chip, one line (Mayank 2026-10-01)
      q.note = 'Includes Free ' + q.h.t + ' Worth MRP \u20b9' + q.h.wt;
    } else if (q.offer === 'festive5') {
      q.note = 'Festive5: Flat 5% off';
    }
    if (sel.offer === 'hamper' && q.offer !== 'hamper' && !inactive && q.cls !== 'none') { q.note = 'Gift hamper not available for this size'; q.warn = true; }
    return qtyText(q, base);
  }

  /* ================================================================ Labels */
  // The 3-part label is printed once by Liquid (island label); JS only swaps in the typed L X W.
  function labelText(d, v, cw) {
    var t = v.label || '';
    if (!cw) return t;
    var p = t.split(' | ');
    if (!CUSTOM_RE.test(p[0] || '')) return t;
    if (p.length >= 2) p[1] = cw.len + ' X ' + cw.wid; else p.push(cw.len + ' X ' + cw.wid);
    return p.join(' | ');
  }
  function optIndex(sel, id) {
    for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === id) return i;
    return -1;
  }
  var Labels = {
    // S8. One writer of the three display selects and the sticky span (PLAN Q7, D2).
    sync: function (inst, v, cw) {
      if (inst.staging === 'inline' || !v) return;
      var id = String(v.id), dims = cw ? cw.len + ' X ' + cw.wid : '';
      ['custom_variant_select', 'custom_mobile_selected_variant', 'custom_only_for_custom'].forEach(function (n) {
        ids(n).forEach(function (sel) {
          var i = optIndex(sel, id);
          if (i < 0) return;
          if (sel.selectedIndex !== i) sel.selectedIndex = i;
          if (!cw) return;
          // syncCustomSizeLabels semantics: only a label already on a Custom variant is rewritten.
          var op = sel.options[i], b = op.text.split('|').map(function (x) { return x.trim(); });
          if (b.length < 2 || !/^custom/i.test(b[0])) return;
          var t = b[0] + ' | ' + dims + ' | ' + b[b.length - 1];
          if (op.text !== t) op.text = t;
        });
      });
      ids('custom_only_for_custom').forEach(function (s) { tog(s, 'hide_custom_options', !cw); });
      ids('custom_variant_select').forEach(function (s) { tog(s, 'hide_custom_options', !!cw); });
      var t = labelText(inst.d, v, cw);
      if (t) ids('mob-sticky-size-display').forEach(function (el) { if (el.textContent.replace(/\s+/g, ' ').trim() !== t) el.textContent = t; });
    },
    // Labels follow the cart id (memory rule). Skipped while a render is in flight: the id is about to
    // change and its own change event re-syncs (deployed L352-358).
    syncFromCart: function (inst) {
      if (inst.staging === 'inline') return;
      var infos = $$('product-info');
      for (var i = 0; i < infos.length; i++) if (infos[i].pendingRequestUrl) return;
      var id = cartId(inst), v = inst.d.byId[id];
      if (!v) return;
      var cw = isCustV(inst.d, v) ? (inst.applied.vid === id ? inst.applied.lw : readLW(inst)) : null;
      Labels.sync(inst, v, cw);
    }
  };
  // Deployed L374-382: the first cart form holding one of THIS product's ids is the truth.
  function cartId(inst) {
    var inp = $$(ID_INPUTS, inst.sc);
    for (var i = 0; i < inp.length; i++) if (inst.d.byId[String(inp[i].value)]) return String(inp[i].value);
    return inp.length ? String(inp[0].value) : '';
  }

  /* ================================================================ Props */
  function writeInputs(el, pairs) {
    var sig = JSON.stringify(pairs);
    if (el.__dfxSig === sig && el.childElementCount === pairs.length) return;
    el.__dfxSig = sig;
    el.textContent = '';
    pairs.forEach(function (p) {
      // Same element today's markup produced: <input type='hidden' name='properties[K]' value='V'>
      var i = D.createElement('input');
      i.type = 'hidden'; i.name = 'properties[' + p[0] + ']'; i.value = String(p[1]);
      el.appendChild(i);
    });
  }
  function hamperJson(h) { return h ? { c: h.c, t: h.t, w: h.w, wt: h.wt, i: h.i } : null; }
  var Props = {
    // S6. Atomic: one call writes the set the variant needs and clears the other one, in every cart
    // form, BEFORE the request - an ATC inside the RTT can never mix the two (order #240551, U-6-27).
    write: function (inst, v, q) {
      var cp = [], ap = [], c = q.cq;
      if (c) {
        cp = [['Length', c.len], ['Width', c.wid], ['Height', c.height], ['d_price', c.d],
          ['selling', convert_rupees(c.price)], ['mrp', convert_rupees(c.mrp)], ['c_size_checked', 'true']];
      } else if (v.g) {
        // PLAN Q10: standard variants keep Length/Width/Height from gokwik_*, blanks omitted.
        [['Length', 0], ['Width', 1], ['Height', 2]].forEach(function (x) { var s = str(v.g[x[1]]); if (s) ap.push([x[0], s]); });
      }
      ids('custom_line_property', inst.sc).forEach(function (el) { writeInputs(el, cp); });
      ids('addition_line_property', inst.sc).forEach(function (el) { writeInputs(el, ap); });
    },
    // D-9.4: only festive-active forms carry the div, so nothing is stamped on the other products.
    writeFestive: function (inst, q) {
      if (!festOf(inst.d) || !q || !q.v) return;
      var pairs = [['_festive', q.offer]];
      if (q.offer === 'hamper') {
        // h = the line's OWN hamper: plan() and the Function give every hamper line its gifts once per unit.
        pairs.push(['_festive_code', q.h.c], ['_hamper', JSON.stringify({ v: 2, h: hamperJson(q.h) })]);
      } else if (q.offer === 'festive5') pairs.push(['_festive_code', String(festOf(inst.d).cfg.festive5_code || 'Festive5')]);
      ids('festive_line_property', inst.sc).forEach(function (el) { writeInputs(el, pairs); });
    },
    // S7 (J3-A-2): every cart form of this product gets the id now, so the ATC is never disabled for
    // the round trip. m24: an '' left by Dawn's setUnavailable is rewritten too.
    writeCartIds: function (inst, vid) {
      vid = String(vid);
      $$(ID_INPUTS, inst.sc).forEach(function (inp) {
        var cur = String(inp.value);
        if (cur === vid || (cur !== '' && !inst.d.byId[cur])) return;
        inp.value = vid;
        fire(inp);
      });
    }
  };

  /* ================================================================ Popup */
  function coarse() { try { return W.matchMedia('(pointer:coarse)').matches; } catch (e) { return false; } }
  function readLW(inst) {
    var l = $('[id="custom_length"]', inst.root), w = $('[id="custom_width"]', inst.root);
    return { len: (l && parseInt(l.value)) || 72, wid: (w && parseInt(w.value)) || 30 };
  }
  function vsOf(inst) { return $('variant-selects', inst.root); } // Dawn inserts the new copy first
  function ctrl(vs, id) { return vs && id != null ? $('[data-option-value-id="' + id + '"]', vs) : null; }
  var Popup = {
    open: function (inst, trigger) {
      if (inst.staging === 'inline' || inst.isOpen || inst.dead) return;
      inst.userTouched = true;
      Memory.userTouch(inst);
      inst.trigger = trigger || 'api';
      inst.lastFocus = D.activeElement;
      inst.staged = copy(inst.applied);
      inst.staged.link = null;
      inst.staged.lv = null; // links mode: every group starts on this product's own value
      Popup.render(inst, inst.staged, true);
      // Coarse pointers only: the phone Back button closes the popup instead of leaving the page (B).
      if (inst.staging === 'popup' && coarse()) {
        inst.token = 'dfx' + Date.now();
        try {
          // GoKwik leaves {sideCart:true} here after its cart is closed with X: going back onto it reopens the cart and locks the page
          if (W.history.state && W.history.state.sideCart) W.history.replaceState(null, '');
          W.history.pushState({ dfxPdp: inst.token }, '');
        } catch (e) { inst.token = null; }
      }
      D.documentElement.classList.add('dfx-pdp-open');
      clearTimeout(inst.hideT);
      lift(inst, true);
      var r = inst.root;
      r.hidden = false;
      void r.offsetWidth; // start the opacity transition from the hidden state
      r.classList.add('show');
      inst.isOpen = true;
      // The current colour is a plain <li> (not focusable): focus lands on the first alternative.
      var f = trigger === 'color' && $('[data-dfx-group="color"] a[data-dfx-link]', r);
      if (!f) { var vs = vsOf(inst); f = vs && ($('fieldset input:checked', vs) || $('fieldset input', vs)); }
      try { (f || $('.dfx-pdp__dialog', r)).focus({ preventScroll: !!f && trigger !== 'color' }); } catch (e) {}
      if (trigger === 'color' && f && f.scrollIntoView) try { f.scrollIntoView({ block: 'nearest' }); } catch (e) {}
      Track(inst, 'open', { sid: inst.sid, trigger: inst.trigger });
    },
    close: function (inst, opt) {
      if (!inst.isOpen) return;
      opt = opt || {};
      inst.isOpen = false;
      inst.staged = null;
      W.__dfxPdpClosedAt = Date.now(); // popup-shared-utils keeps other popups back for a few seconds after
      var r = inst.root;
      r.classList.remove('show');
      clearTimeout(inst.hideT);
      inst.hideT = setTimeout(function () { if (!inst.isOpen) { r.hidden = true; if (!hamperShown(inst)) lift(inst, false); } }, 150); // D-4.2 fade-out
      D.documentElement.classList.remove('dfx-pdp-open');
      // m11: our entry is popped first; Dawn's updateURL at R then lands on the PDP entry (R0).
      if (!opt.noHistory && inst.token && W.history.state && W.history.state.dfxPdp === inst.token) {
        inst.popPending = true;
        W.history.back();
      }
      inst.token = null;
      if (opt.scroll) W.scrollTo({ top: 0, behavior: 'smooth' });
      var lf = inst.lastFocus;
      if (lf && lf.focus && D.contains(lf)) try { lf.focus({ preventScroll: true }); } catch (e) {}
    },
    cancel: function (inst, via, noHistory) {
      if (!inst.isOpen) return;
      if (inst.staging === 'popup') Popup.render(inst, inst.applied, true); // discard the staged state
      inst.staged = null;
      Popup.close(inst, { noHistory: noHistory });
      Track(inst, 'cancel', { sid: inst.sid, via: via });
    },
    confirm: function (inst) {
      if (!inst.isOpen) return;
      var s = inst.staged;
      if (s && s.link) return linkNav(inst, s);
      if (inst.staging !== 'popup' || inst.d.mode === 'links') return Popup.close(inst, {});
      Commit.apply(inst, s, { source: 'popup' });
    },
    render: function (inst, s, sync) {
      Popup.syncChecked(inst, s.o);
      Popup.availability(inst, s, sync);
      Popup.customBlock(inst, s);
      var l = $('[id="custom_length"]', inst.root), w = $('[id="custom_width"]', inst.root);
      if (s.lw && l && String(l.value) !== String(s.lw.len)) l.value = s.lw.len;
      if (s.lw && w && String(w.value) !== String(s.lw.wid)) w.value = s.lw.wid;
      Links.render(inst, s);
      Popup.preview(inst, s);
    },
    // Radios (and dropdown options, m5 / D-11-58) follow the selection; Dawn's selectedOptionValues
    // reads exactly these checked/selected states when the module dispatches.
    syncChecked: function (inst, o) {
      var d = inst.d, vs = vsOf(inst);
      if (!vs) return;
      (o || []).forEach(function (i, k) {
        var x = d.values[k] && d.values[k][i], c = x && ctrl(vs, x.id);
        if (!c) return;
        if (c.tagName === 'OPTION') {
          var sel = c.parentNode;
          if (sel.selectedIndex !== c.index) sel.selectedIndex = c.index;
          arr(sel.options).forEach(function (op) { setAttr(op, 'selected', op === c ? 'selected' : null); });
        } else if (!c.checked) c.checked = true;
      });
    },
    // D-4.4: only radios whose state differs are touched, in ONE frame per tap.
    availability: function (inst, s, sync) {
      var run = function () {
        var d = inst.d, vs = vsOf(inst);
        if (!vs || inst.staging !== 'popup') return;
        var skip = isCustIdx(d, s.o[0]) ? d.dk : -1;
        d.values.forEach(function (vals, k) {
          vals.forEach(function (x, i) {
            var r = $('input[data-option-value-id="' + x.id + '"]', vs);
            if (!r) return;
            // data-sku = Liquid's value.variant.sku for the STAGED selection (this value + the other staged
            // values, '' when no such variant). component-product-variant-picker.css:142-143 hides dimension /
            // height values whose data-sku is '' - that is how the server shows only the selected Size's
            // dimensions. The popup does not fetch per tap, so it recomputes it; otherwise a new Size kept the
            // old Size's dimensions (greyed) and hid its own (Mayank 2026-09-26).
            if (k > 0) {
              var o2 = s.o.slice(); o2[k] = i;
              var ev = exact(d, o2, k === skip ? -1 : skip);
              setAttr(r, 'data-sku', ev ? (ev.sku || '') : '');
            }
            var un = !available(d, s.o, k, i, skip);
            if (r.hasAttribute('data-unavailable') === un) return;
            // The disabled ATTRIBUTE + data-unavailable + aria-disabled, never the .disabled class
            // (GoKwik's observer strips that class site-wide, U-6-70).
            setAttr(r, 'disabled', un ? '' : null); setAttr(r, 'data-unavailable', un ? '1' : null); setAttr(r, 'aria-disabled', un ? 'true' : null);
          });
        });
      };
      if (sync || !W.requestAnimationFrame) run(); else W.requestAnimationFrame(run);
    },
    customBlock: function (inst, s) {
      var d = inst.d, cust = isCustIdx(d, s.o[0]), vs = vsOf(inst);
      // The dimension fieldset is found through its radios, not its class (Dimensions vs Dimension).
      var dr = d.dk >= 0 && d.values[d.dk] && d.values[d.dk][0] && ctrl(vs, d.values[d.dk][0].id);
      var fs = dr && dr.closest('fieldset');
      if (fs) tog(fs, 'hide_custom_options', cust);
      $$('.custom_option_main_fordimension', inst.root).forEach(function (el) { tog(el, 'hide_custom_options', !cust); });
    },
    restage: function (inst) {
      var s = inst.staged;
      settle(inst.d, s);
      Popup.syncChecked(inst, s.o);
      Popup.availability(inst, s, false);
      Popup.customBlock(inst, s);
      Popup.preview(inst, s);
    },
    preview: function (inst, s) {
      var d = inst.d, r = inst.root, q = quoteOf(d, stdSel(d, s), qtyOf(inst)), v = q.v;
      // Links mode: the footer quotes the product Confirm opens (its node), not this page's variant.
      var lq = d.mode === 'links' && s.link ? linkQuote(d, s.link.node) : null;
      setText($('[data-dfx-preview-price]', r), lq ? lq.priceText : v ? q.priceText : '');
      setText($('[data-dfx-preview-pct]', r), lq ? lq.chip : v ? q.chipPopup : '');
      setText($('[data-dfx-preview-mrp]', r), lq ? lq.mrpText : v ? q.mrpText : '');
      var de = $('[data-dfx-preview-deal]', r), dt = lq ? dealText(inst, lq.d, lq.dl) : v ? dealText(inst, v.d, v._dl) : '';
      setHTML(de, dealQty(q.offer === 'hamper' ? '' : dt, q.qty));
      hideEl(de, !dt);
      // No 'Opens <product>' line when a colour / seater link is staged (Mayank 2026-09-26); sold-out / unavailable stay.
      // Offer text stays off the popup footer (Mayank 2026-09-28): only sold out / unavailable / the no-hamper warning.
      var note = s.link ? '' : !v ? (d.strings.unavail || 'Unavailable') : !v.a ? (d.strings.sold || 'Sold out') : q.warn ? q.note : '';
      var n = $('[data-dfx-preview-note]', r);
      setText(n, note);
      hideEl(n, !note);
      Festive.mirror(inst, s, q);
    },
    // Root capture listener: a staged tap is swallowed here so VariantSelects never publishes and
    // nothing on the PDP moves before Confirm (rule 3.3). Document-capture listeners still see it.
    onChange: function (inst, e) {
      var t = e.target, s = inst.staged, d = inst.d;
      if (!t || e.__dfxApply) return;
      if (t.closest('variant-selects')) {
        if (inst.staging !== 'popup') { if (inst.staging === 'passthrough') presettle(inst, t); return; }
        e.stopPropagation();
        if (!s) { Popup.syncChecked(inst, inst.applied.o); return; }
        var op = t.tagName === 'SELECT' ? t.options[t.selectedIndex] : t;
        var ki = op && d.vidx[String(op.getAttribute('data-option-value-id'))];
        if (!ki || t.hasAttribute('data-unavailable')) { Popup.syncChecked(inst, s.o); return; }
        s.o[ki[0]] = ki[1];
        Popup.restage(inst);
        return;
      }
      if (t.id === 'custom_length' || t.id === 'custom_width') {
        var lw = readLW(inst);
        if (s && inst.staging === 'popup') { s.lw = lw; Popup.preview(inst, s); return; }
        // passthrough: an L/W change applies at once (no request - the variant is unchanged).
        var a = copy(inst.applied);
        a.lw = lw;
        Commit.apply(inst, a, { source: 'render' });
        return;
      }
      if (s && t.closest('[data-dfx-offer-picker]')) { s.offer = t.value; Popup.preview(inst, s); }
    },
    onClick: function (inst, e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var c = t.closest('[data-dfx-cancel]');
      if (c) { e.preventDefault(); return Popup.cancel(inst, c.getAttribute('data-dfx-cancel')); }
      if (t.closest('[data-dfx-confirm]')) { e.preventDefault(); return Popup.confirm(inst); }
      if (t.closest('[data-dfx-hamper-chip]')) return Festive.openHamper(inst, 'popup_chip');
      var s = inst.staged;
      if (!s) return;
      var it = linkView(inst.d) && t.closest('[data-dfx-group] [data-dfx-val]');
      if (it) { e.preventDefault(); return Links.pick(inst, s, it); }
      var a = t.closest('a[data-dfx-link]');
      if (a) {
        // A colour / seater is another PRODUCT: staged here, navigated only on Confirm (D-4.5).
        e.preventDefault();
        var g = a.closest('[data-dfx-group]');
        s.link = { group: g ? g.getAttribute('data-dfx-group') : '', url: a.href, t: a.textContent.trim() };
        Popup.render(inst, s, true);
      } else if (t.closest('.is-current') && s.link) { s.link = null; Popup.render(inst, s, true); }
    },
    // Enter / Space on a link item (the current <li> gets tabindex 0 in Links.render).
    onKey: function (inst, e) {
      var t = e.target, k = e.key;
      if ((k !== 'Enter' && k !== ' ' && k !== 'Spacebar') || !t || !t.matches || !inst.staged) return;
      if (!t.matches('[data-dfx-group] [data-dfx-val]') || !linkView(inst.d)) return;
      e.preventDefault(); // no native link click / page scroll: the pick below is the only action
      Links.pick(inst, inst.staged, t);
    }
  };
  var Links = {
    // A tap changes ONLY its group; the other groups keep their staged values (links-combo-fix).
    pick: function (inst, s, el) {
      var L = linkView(inst.d), fs = el.closest('[data-dfx-group]');
      var g = fs && fs.getAttribute('data-dfx-group'), val = el.getAttribute('data-dfx-val');
      if (!L || !g || val == null) return;
      var r = linkResolve(L, s.lv, g, val), n = r.node;
      s.lv = r.lv;
      // Not in the node table (a capped table): the tapped item's own product, as before the fix.
      if (!n && el.href) n = { u: el.href, t: el.textContent.trim(), p: null };
      s.link = n && n !== L.cur ? { group: g, url: n.u, t: n.t, node: n } : null;
      Popup.render(inst, s, true);
    },
    // Exactly one item per group looks selected (the staged value; this product's own item while it
    // is unchanged) and items that cannot combine with the other staged values are struck through.
    render: function (inst, s) {
      var L = linkView(inst.d);
      if (!L) {
        $$('[data-dfx-link]', inst.root).forEach(function (a) { setAttr(a, 'aria-pressed', s.link && s.link.url === a.href ? 'true' : null); });
        $$('.dfx-pdp__group', inst.root).forEach(function (fs) { setAttr(fs, 'data-dfx-moved', $('[aria-pressed="true"]', fs) ? '' : null); });
        return;
      }
      var lv = (s && s.lv) || L.cur.k;
      $$('[data-dfx-group]', inst.root).forEach(function (fs) {
        var g = fs.getAttribute('data-dfx-group');
        if (L.keys.indexOf(g) < 0) return;
        var want = lv[g], moved = want != null && !lkEq(want, L.cur.k[g]), hit = false;
        $$('[data-dfx-val]', fs).forEach(function (el) {
          var val = el.getAttribute('data-dfx-val'), on = false;
          if (el.hasAttribute('data-dfx-link')) {
            on = moved && !hit && lkEq(val, want);
            if (on) hit = true;
            setAttr(el, 'aria-pressed', on ? 'true' : null);
          } else setAttr(el, 'tabindex', '0');
          setAttr(el, 'data-dfx-unavail', on || linkOpen(L, lv, g, val) ? null : '');
        });
        setAttr(fs, 'data-dfx-moved', moved ? '' : null);
      });
    }
  };
  // passthrough staging (a non-button picker_type set in the editor): Dawn gets every tap, but later
  // options are re-ticked first so the request names an existing variant (the resolver's job).
  function presettle(inst, t) {
    var d = inst.d, vs = vsOf(inst), op = t.tagName === 'SELECT' ? t.options[t.selectedIndex] : t;
    var ki = op && d.vidx[String(op.getAttribute('data-option-value-id'))];
    if (!ki || !vs) return;
    var o = copy(inst.applied.o) || [];
    d.values.forEach(function (vals, k) {
      vals.forEach(function (x, i) { var c = ctrl(vs, x.id); if (c && (c.checked || c.selected)) o[k] = i; });
    });
    o[ki[0]] = ki[1];
    var s = { o: o, inC: inst.applied.inC, dimSave: inst.applied.dimSave };
    settle(d, s);
    Popup.syncChecked(inst, s.o);
  }
  function linkNav(inst, s) {
    if (inst.d.mode === 'picker') {
      var v = exact(inst.d, s.o, isCustIdx(inst.d, s.o[0]) ? inst.d.dk : -1);
      if (v) Memory.persist(inst, v); // a bed / combo lands on the same size
    }
    var url = s.link.url;
    Track(inst, 'link_nav', { sid: inst.sid, group: s.link.group, url: url });
    var entry = inst.token && W.history.state && W.history.state.dfxPdp === inst.token;
    Popup.close(inst, { noHistory: true });
    if (!entry) return W.location.assign(url);
    // J3-6: pop our entry first so Back from the target is one press; 150 ms fallback.
    inst.nav = url;
    inst.popPending = true;
    W.history.back();
    clearTimeout(inst.popT);
    inst.popT = setTimeout(function () { if (inst.nav) { var u = inst.nav; inst.nav = null; W.location.assign(u); } }, 150);
  }
  function qtyOf(inst) {
    var q = (inst.pi && $('.quantity__input', inst.pi)) || $('.quantity__input[name="quantity"]');
    return Math.max(1, parseInt(q && q.value) || 1);
  }

  /* ================================================================ Commit */
  var Commit = {
    // D-5.2 S-steps; m10: which steps run depends on the source.
    //   popup S0-S12 / memory S0b + S2-S12 / keyboard S0b + S1 (no scroll/history) + S2-S12 /
    //   boot S0b + S3-S10 (no dispatch) / festive S3 + writeFestive + S9 + S11 / render S2-S10
    apply: function (inst, sel, o) {
      var d = inst.d, src = o.source, prev = inst.applied;
      if (d.mode === 'links') { if (src === 'popup') Popup.close(inst, {}); return; }
      sel.lw = sel.lw || readLW(inst);
      // Custom typed as a standard size -> that standard variant (stdSel); the radios follow like S0b.
      var std = src === 'popup' || src === 'memory' ? stdSel(d, sel) : sel, conv = std !== sel;
      sel = std;
      // S0b (memory / keyboard / boot): the radios take the selection so Dawn's selectedOptionValues
      // names it; an exact variant is never re-settled (a sold-out landing stays what it is).
      if (conv || (src !== 'popup' && src !== 'festive' && src !== 'render')) Popup.render(inst, sel, true);
      var q = quoteOf(d, sel, qtyOf(inst)), v = q.v;
      var vid = v ? String(v.id) : '';
      var changed = vid !== prev.vid || !v;
      if (src === 'popup' || src === 'keyboard') {
        Popup.close(inst, { scroll: src === 'popup' && (inst.trigger === 'pill' || inst.trigger === 'sticky') });
      }
      try {
        if (v) {
          var full = src !== 'festive';
          if (src !== 'boot' && full && inst.staging !== 'inline') Memory.persist(inst, v);
          Commit.writePrice(inst, q);
          if (full) { Commit.specRows(inst, vid); Commit.writeStrip(inst, v); Props.write(inst, v, q); }
          Props.writeFestive(inst, q);
          if (full) { Props.writeCartIds(inst, vid); Labels.sync(inst, v, q.cq ? q.custom : null); }
          Gokwik.push(inst, q);
          if (full && inst.staging !== 'inline') { Sticky.mirrorNav(inst, vid, !v.a); Sticky.writeQty(); }
          Festive.render(inst, q);
        }
      } catch (err) { warn('apply', err); }
      inst.applied = { vid: vid, o: sel.o.slice(), lw: sel.lw, offer: sel.offer, inC: !!sel.inC, dimSave: sel.dimSave == null ? null : sel.dimSave };
      if (src === 'festive') {
        if (!o.silent) Track(inst, 'festive', { sid: inst.sid, offer: q.offer, code: q.h && q.offer === 'hamper' ? q.h.c : '', sizeClass: q.cls, source: o.from || 'block' });
      } else if (src === 'popup' || src === 'memory' || src === 'keyboard') {
        Track(inst, 'confirm', { sid: inst.sid, variantId: v ? v.id : null, prevVariantId: prev.vid, changed: changed, custom: q.custom, offer: q.offer, link: null, source: src });
      }
      if (!changed || src === 'boot' || src === 'festive' || src === 'render' || o.dispatch === false) return;
      Commit.dispatch(inst, prev.o, sel.o, vid, src === 'memory' ? o.mem : null);
    },
    // S12: exactly one change on the first option that moved (else the Size) -> VariantSelects ->
    // product-info -> ONE section fetch. The ATC is re-enabled in the same task (J3-A-2).
    dispatch: function (inst, prevO, o, vid, mem) {
      var d = inst.d, k = 0, n = o.length;
      while (k < n && prevO && prevO[k] === o[k]) k++;
      if (k >= n) k = 0;
      var x = d.values[k] && d.values[k][o[k]];
      if (!x || !ctrl(vsOf(inst), x.id)) return;
      clearTimeout(inst.watchT);
      inst.landing = { vid: vid, k: k, id: x.id, tries: 0, mem: mem, t0: 0 };
      Commit.send(inst);
    },
    send: function (inst) {
      var L = inst.landing, c = L && ctrl(vsOf(inst), L.id);
      if (!c) return;
      L.t0 = Date.now();
      fire(c.tagName === 'OPTION' ? c.parentNode : c);
      var pf = inst.pi && inst.pi.productForm, v = inst.d.byId[L.vid];
      if (pf && v) {
        try { pf.toggleSubmitButton(!v.a, inst.d.strings.sold); pf.handleErrorMessage(); } catch (e) {}
      }
      Commit.watch(inst);
    },
    // D-5.4: product-info.pendingRequestUrl is polled only while landing (never a free-running timer).
    watch: function (inst) {
      clearTimeout(inst.watchT);
      inst.watchT = setTimeout(function tick() {
        var L = inst.landing;
        if (!L) return;
        var el = Date.now() - L.t0, pend = inst.pi && inst.pi.pendingRequestUrl;
        if (!pend || el > 8000) return Commit.retryOrTimeout(inst);
        inst.watchT = setTimeout(tick, 250);
      }, 250);
    },
    retryOrTimeout: function (inst) {
      var L = inst.landing;
      if (!L) return;
      if (!L.tries && !L.noRetry) {
        L.tries = 1;
        inst.watchT = setTimeout(function () { if (inst.landing === L) Commit.send(inst); }, 1500);
        return;
      }
      inst.landing = null;
      // S6/S7 already made the PDP and every cart form agree, so nothing is reverted (D-5.4).
      Track(inst, 'landing_timeout', { sid: inst.sid, requested: L.vid, cart: cartId(inst) });
      if (L.mem) Memory.done(L.mem, false);
    },
    // R1: Dawn wrote the requested id into the cart forms.
    landed: function (inst) {
      var L = inst.landing;
      clearTimeout(inst.watchT);
      inst.landing = null;
      if (inst.popPending) inst.landedEarly = true; // R0 re-issues the URL in the popstate handler
      Labels.syncFromCart(inst);
      var q = quoteOf(inst.d, inst.applied, qtyOf(inst));
      Sticky.mirrorNav(inst, inst.applied.vid, !(q.v && q.v.a));
      Props.writeFestive(inst, q);
      Gokwik.push(inst, q);
      Track(inst, 'applied', { sid: inst.sid, variantId: q.v ? q.v.id : null });
      if (L && L.mem) Memory.done(L.mem, cartId(inst) === L.vid);
    },
    // R7: Dawn found no variant (stale island): a consistent "unavailable" state (PLAN U-6-6).
    unavailable: function (inst) {
      var L = inst.landing;
      clearTimeout(inst.watchT);
      inst.landing = null;
      var ou = offersRoot(inst), strip = ou && $('.dfx-ou__strip', ou);
      if (strip) strip.style.display = 'none';
      ids('custom_line_property', inst.sc).concat(ids('addition_line_property', inst.sc), ids('festive_line_property', inst.sc))
        .forEach(function (el) { writeInputs(el, []); });
      Sticky.mirrorNav(inst, '', true);
      inst.applied.vid = ''; // the next open still starts from the last real selection (o kept)
      if (L && L.mem) Memory.done(L.mem, false);
    },
    // S3 (+R3): the price block of THIS section only (PLAN Q15), both copies of each node (U-6-17).
    writePrice: function (inst, q) {
      var box = D.getElementById('price-' + inst.sid), v = q.v;
      if (!box || !v) return;
      var custom = !!q.cq;
      var pAttr = (v.p / 100).toFixed(2);
      $$('.custom_selling_price', box).forEach(function (el) { setText(el, q.priceText); setAttr(el, 'variants_price', pAttr); });
      $$('.custom_mrp_price', box).forEach(function (el) { setText(el, q.mrpText); setAttr(el, 'variants_compare_price', v.cm === '' ? '' : (v.c / 100).toFixed(2)); });
      $$('.saveamount.only_for_card_product', box).forEach(function (el) { setText(el, q.chipCard); });
      $$('.saveamount.for_pdf', box).forEach(function (el) {
        if (q.chipSub) setHTML(el, q.chipBlock + ' <small class="dfx-chip-sub">' + q.chipSub + '</small>');
        else { el.__dfxH = null; setText(el, q.chipBlock); }
      });
      var pr = $('.price', box);
      tog(pr, 'price--sold-out', !v.a);
      setText($('#selected_variant_sku', box), v.sku);
      setText($('#selected_variant_simple_sku', box), v.ss); // combo_sku of the delivery check
      var l = v.l || [], g = v.g || [];
      setText($('#variant_block_product_group_l', box), l[0]);
      setText($('#variant_block_product_group_l5', box), l[1]);
      setText($('#variant_block_product_group_l6', box), l[2]);
      setText($('#variant_block_custom_length', box), custom ? q.cq.len : g[0]);
      setText($('#variant_block_custom_width', box), custom ? q.cq.wid : g[1]);
      setText($('#variant_block_custom_height', box), custom ? q.cq.height : g[2]);
      if (inst.d.strip && inst.d.strip.on === false) {
        // price.liquid:170-174 deal line (Airboost/opera): inserted/removed like Liquid does.
        var dp = $('[data-dfx-deal-price]', inst.pi || D), raw = q.offer === 'hamper' ? '' : v.d && v.d.raw, line = $('.variant_level_offer_section', dp || box); // dp: Deal price block
        if (raw) {
          if (!line) {
            line = D.createElement('div');
            line.className = 'variant_level_offer_section';
            var sku = $('#selected_variant_sku', box);
            if (dp) dp.appendChild(line); else if (sku && sku.parentNode) sku.parentNode.insertBefore(line, sku.nextSibling); else box.appendChild(line);
          }
          setHTML(line, dealQty(raw, q.qty));
        } else if (line) line.parentNode.removeChild(line);
      }
      if (festOf(inst.d)) {
        var note = $('[data-dfx-fo-note]', box);
        if (!note) {
          var sale = $('.price__sale', box);
          note = D.createElement('small');
          note.className = 'dfx-fo__note';
          note.setAttribute('data-dfx-fo-note', '');
          if (sale && sale.parentNode) sale.parentNode.insertBefore(note, sale.nextSibling); else box.appendChild(note);
        }
        setText(note, q.note);
        hideEl(note, !q.note);
      }
      emit('dfx:pdp-written', { sid: inst.sid }); // assets/dfx-delivery.js re-checks the pincode
    },
    specRows: function (inst, vid) {
      $$('.var_specification_meta', inst.sc).forEach(function (el) { tog(el, 'hide_var_meta', el.getAttribute('data-id') !== vid); });
    },
    // S5: the strip TEXT comes pre-rendered from the island (dfx-deal-strip-text); the module never
    // parses deal text (D13). syncStripState keeps offer-unlock's locked/unlocked rule in one place.
    writeStrip: function (inst, v) {
      var ou = offersRoot(inst), strip = ou && $('.dfx-ou__strip', ou);
      if (!strip) return;
      var dd = v.d || null, l2 = dd ? dd.l2 : '';
      setHTML($('[data-dfx-strip-unlocked]', strip), dd ? dd.l1 : '');
      setHTML($('[data-dfx-strip-locked]', strip), v._dl || '');
      var sub = $('.dfx-ou__strip-sub', strip), box = $('.dfx-ou__strip-text', strip);
      if (l2) {
        if (!sub && box) { sub = D.createElement('span'); sub.className = 'dfx-ou__strip-sub'; box.appendChild(sub); }
        setHTML(sub, l2);
      } else if (sub) sub.parentNode.removeChild(sub);
      strip.style.display = '';
      syncStrip(ou);
    },
    // R4: the server's strip wins over S5 (a metafield may have changed mid-session).
    copyStrip: function (inst, doc) {
      var ou = offersRoot(inst);
      if (!ou || !doc || !doc.querySelector) return;
      var fresh = doc.querySelector('[data-dfx-offer-unlock] .dfx-ou__strip'), cur = $('.dfx-ou__strip', ou);
      if (!fresh) { if (cur) cur.style.display = 'none'; return; }
      if (!cur) {
        cur = D.importNode(fresh, true);
        var h = $('.dfx-ou__heading', ou);
        if (h) h.parentNode.insertBefore(cur, h); else ou.insertBefore(cur, ou.firstChild);
      } else {
        var a = $('.dfx-ou__strip-text', cur), b = fresh.querySelector('.dfx-ou__strip-text');
        if (a && b) { if (a.innerHTML !== b.innerHTML) a.innerHTML = b.innerHTML; } else if (cur.innerHTML !== fresh.innerHTML) cur.innerHTML = fresh.innerHTML;
        cur.style.display = '';
      }
      syncStrip(ou);
    },
    // R2-R4 (pubsub variantChange, published by Dawn after its swaps in the same task).
    onVariantChange: function (inst, data) {
      var nv = data.variant;
      if (!nv || !inst.d.byId[String(nv.id)]) return; // another product's render (quick-add)
      Island.refresh(inst.d, data.html);
      var id = String(nv.id), v = inst.d.byId[id];
      if (v && id !== inst.applied.vid) {
        // A variant the module did not ask for (passthrough tap, server resolved elsewhere):
        // cart truth wins and the PDP follows it (no dispatch).
        clearTimeout(inst.watchT);
        if (inst.landing && inst.landing.mem) Memory.done(inst.landing.mem, false);
        inst.landing = null;
        var a = copy(inst.applied);
        a.o = v.o.slice();
        a.inC = isCustV(inst.d, v);
        Commit.apply(inst, a, { source: 'render' });
      } else if (v) {
        Commit.specRows(inst, id);
        Commit.writePrice(inst, quoteOf(inst.d, inst.applied, qtyOf(inst))); // R3: same task, no paint
      }
      if (inst.isOpen && inst.staged) {
        if (inst.staging !== 'popup') inst.staged = copy(inst.applied);
        Popup.render(inst, inst.staged, true); // Dawn replaced the radios under the open popup
      }
      else Popup.customBlock(inst, inst.applied);
      Commit.copyStrip(inst, data.html);
    }
  };
  // The deal line the PDP shows after Confirm, for the popup footer: the offers strip (locked teaser while
  // offers are locked, else line 1 + line 2 - syncStripState's rule) or, where the strip is off
  // (Airboost/opera), price.liquid's deal line (raw deal_price). Text is pre-rendered by dfx-deal-strip-text.
  function dealText(inst, dd, dl) {
    if (inst.d.strip && inst.d.strip.on === false) return dd && dd.raw ? dd.raw : '';
    var ou = offersRoot(inst);
    if (!ou) return '';
    if (ou.classList.contains('dfx-ou--locked')) return dl || '';
    return dd && dd.l1 ? dd.l1 + (dd.l2 ? ' <span class="dfx-pdp__deal-sub">' + dd.l2 + '</span>' : '') : '';
  }
  // >=750px the info column is position:sticky + z-index 2: a stacking context under the header (z 4), so a
  // fixed popup inside it would sit under the header. Raising the column painted its scrolled-up top
  // (title, MRP line) over the header; instead, while a dialog is open, the column becomes position:relative
  // at the offset sticky gave it (same pixels, no stacking context) and the dialog stacks at the page root.
  function lift(inst, on) {
    var col = inst.root.parentElement && inst.root.parentElement.closest('.product__info-container');
    if (on) {
      if (inst.lifted || !col || W.getComputedStyle(col).position !== 'sticky') return;
      var st = col.style, prev = { p: st.position, t: st.top, z: st.zIndex }, y0 = col.getBoundingClientRect().top;
      st.position = 'relative';
      st.top = '0px';
      st.top = (y0 - col.getBoundingClientRect().top) + 'px';
      st.zIndex = 'auto';
      inst.lifted = { col: col, prev: prev };
    } else if (inst.lifted) {
      var L = inst.lifted, s2 = L.col.style;
      s2.position = L.prev.p; s2.top = L.prev.t; s2.zIndex = L.prev.z;
      inst.lifted = null;
    }
  }
  function hamperShown(inst) { return !!$('[data-dfx-hamper].show', inst.pi || D); }
  function offersRoot(inst) {
    return (inst.pi && $('[data-dfx-offer-unlock]', inst.pi)) || (!inst.pi && $('[data-dfx-offer-unlock]')) || null;
  }
  function syncStrip(ou) {
    var u = W.DfxOfferUnlock;
    if (u && typeof u.syncStripState === 'function') try { u.syncStripState(ou); } catch (e) {}
  }

  /* ================================================================ Memory */
  // Port of the former 478-line size-memory build: same key, cookie, merge, tiers and event.
  var KEY = 'dfx_size_pref';
  var COOKIE_DAYS = 30;
  function readCookie(name) {
    var m = D.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function writeCookie(name, value, days) {
    try {
      D.cookie = name + '=' + encodeURIComponent(value) +
        '; path=/; max-age=' + (days * 86400) + '; samesite=lax';
    } catch (e) {}
  }
  function load() {
    var raw = '';
    try { raw = W.localStorage.getItem(KEY) || ''; } catch (e) {}
    if (!raw) raw = readCookie(KEY);
    if (!raw) return null;
    try {
      var p = JSON.parse(raw);
      return p && typeof p === 'object' ? p : null;
    } catch (e) { return null; }
  }
  function save(pref) {
    var raw = JSON.stringify(pref);
    try { W.localStorage.setItem(KEY, raw); } catch (e) {}
    writeCookie(KEY, raw, COOKIE_DAYS);
  }
  var TIERS = [
    ['size', 'dimension', 'height'],
    ['dimension', 'height'],
    ['size', 'dimension'],
    ['dimension'],
    ['size', 'height'],
    ['size']
  ];
  function slotVal(d, v, s) { return has(d.slot, s) ? optVal(d, v, d.slot[s]) : null; }
  var Memory = {
    // Products without a size/dimension/height slot are ignored (deployed L75-81 parity).
    slots: function (inst) {
      var s = inst.d.slot;
      return inst.d.mode === 'picker' && inst.staging !== 'inline' && (has(s, 'size') || has(s, 'dimension') || has(s, 'height'));
    },
    // Apply on load: never in the theme editor (B) nor for a quick-add root.
    enabled: function (inst) {
      return Memory.slots(inst) && !(W.Shopify && W.Shopify.designMode) && !inst.d.flags.designMode;
    },
    // S2: raw option strings of the RESOLVED variant, merged never replaced (L126-137); typed
    // custom L/W is never stored. Only island-slotted options take part (m4).
    persist: function (inst, v) {
      if (!Memory.slots(inst)) return;
      var d = inst.d, merged = load() || {};
      ['size', 'dimension', 'height'].forEach(function (s) { var x = slotVal(d, v, s); if (x) merged[s] = x; });
      merged.ts = Date.now();
      save(merged);
    },
    resolve: function (d, pref) {
      var avail = d.variants.filter(function (v) { return v.a; });
      if (!avail.length) return null;
      for (var t = 0; t < TIERS.length; t++) {
        var want = TIERS[t];
        var usable = want.every(function (s) { return pref[s] && has(d.slot, s); });
        if (!usable) continue; // this product has no such option, or nothing saved for it
        var hit = avail.filter(function (v) {
          return want.every(function (s) { return norm(slotVal(d, v, s)) === norm(pref[s]); });
        })[0];
        if (hit) return { variant: hit, tier: want.join('+') };
      }
      return { variant: avail[0], tier: 'first-available' };
    },
    // L442-471. The apply goes through Commit.apply - the same S-steps as a Confirm (J3-A-1).
    run: function (inst) {
      Labels.syncFromCart(inst);
      if (inst.userTouched || !Memory.enabled(inst)) return;
      var d = inst.d, cur = d.byId[inst.applied.vid];
      if (/[?&]variant=/.test(W.location.search)) { if (cur) Memory.persist(inst, cur); return; } // deep link wins
      var pref = load();
      if (!pref || (!pref.size && !pref.dimension && !pref.height)) { if (cur) Memory.persist(inst, cur); return; } // seed
      var picked = Memory.resolve(d, pref);
      if (!picked) return;
      if (String(picked.variant.id) === String(d.selected)) return; // already right - no flicker
      var sel = copy(inst.applied);
      sel.o = picked.variant.o.slice();
      sel.inC = isCustV(d, picked.variant);
      var mem = { id: picked.variant.id, tier: picked.tier, done: false };
      Commit.apply(inst, sel, { source: 'memory', mem: mem });
      if (!inst.landing) Memory.done(mem, cartId(inst) === String(picked.variant.id)); // nothing to wait for
    },
    // J1-8: bare push, deployed keys and order, after the landing (true) or the T path (false).
    done: function (mem, ok) {
      if (!mem || mem.done) return;
      mem.done = true;
      try {
        W.dataLayer = W.dataLayer || [];
        W.dataLayer.push({
          event: 'dfx_size_memory_applied',
          dfx_size_match: mem.tier,
          dfx_size_variant: mem.id,
          dfx_size_applied: !!ok
        });
      } catch (e) {}
    },
    // A shopper interaction during a memory landing stops the wait; nothing is reverted (J3-A-3).
    userTouch: function (inst) {
      var L = inst.landing;
      if (L && L.mem) { Memory.done(L.mem, false); L.mem = null; L.noRetry = true; }
    }
  };

  /* ================================================================ Sticky */
  var Sticky = {
    // Page layer (P-10): runs on every product page, with or without a popup root.
    initPage: function () {
      var q = $('.product-form__quantity');
      if (q && typeof W.IntersectionObserver === 'function') {
        // theme.liquid:1659-1682 semantics and the SAME three targets (D-3.4).
        new W.IntersectionObserver(function (entries) {
          if ((W.scrollY || W.pageYOffset) <= 100) return;
          var on = !entries[0].isIntersecting;
          $$('.custom_mobile_form_btn .form_btn_block, product-form, .mobile_custom_selected').forEach(function (el) { tog(el, 'show_selected_variant', on); });
        }, { threshold: 0 }).observe(q);
      }
      if ($('.custom_mobile_form_btn')) {
        // theme.liquid:1858-1866 (opera bar) as a passive, rAF-throttled listener.
        var raf = 0;
        var bar = function () {
          raf = 0;
          var y = W.pageYOffset || D.documentElement.scrollTop || 0;
          $$('.custom_mobile_form_btn').forEach(function (el) { tog(el, 'hide_fixedclass_sticky_btn', !(y > 100)); });
        };
        W.addEventListener('scroll', function () { if (!raf) raf = W.requestAnimationFrame ? W.requestAnimationFrame(bar) : (bar(), 0); }, { passive: true });
        bar();
      }
    },
    // PLAN Q5: ONE trusted click on the sticky button -> one submit (requestSubmit fires the capture
    // listeners once instead of twice). Sold out: silent no-op, the sticky button is never disabled.
    proxyAtc: function (e, btn) {
      if (e && e.preventDefault) e.preventDefault();
      var real = D.getElementById('ProductSubmitButton-' + (btn && btn.getAttribute('data-section-id')));
      if (!real || real.disabled) return;
      if (real.form && real.form.requestSubmit) real.form.requestSubmit(real); else real.click();
    },
    // S10/R6: the Airboost desktop sticky-nav form (replaces its 250 ms poller).
    mirrorNav: function (inst, vid, sold) {
      if (inst.staging === 'inline') return;
      var inp = $('.pdp-sticky-nav .product-variant-id'), b = $('.pdp-sticky-nav .product-form__submit');
      if (inp && vid && inp.value !== vid) inp.value = vid;
      if (inp && inp.disabled !== !!sold) inp.disabled = !!sold;
      if (b && b.disabled !== !!sold) {
        b.disabled = !!sold;
        var sp = $('span', b);
        if (sp) sp.textContent = sold ? (inst.d.strings.sold || 'Sold out') : (inst.d.strings.add || 'Add to cart');
      }
    },
    writeQty: function () {
      var q = $('.quantity__input[name="quantity"]');
      if (q) $$('.inner_qty_block span').forEach(function (s) { setText(s, q.value); });
    }
  };

  /* ================================================================ Gokwik */
  var Gokwik = {
    // S9 / R5 / boot (PLAN Q13): the offer widget follows the price actually shown x quantity.
    push: function (inst, q) {
      if (inst.staging === 'inline' || !q || !q.v) return;
      var amt = String(q.pp / 100 * q.qty), id = String(q.v.id);
      $$('gokwik-offer-widget').forEach(function (w) { setAttr(w, 'amount', amt); setAttr(w, 'product-id', id); });
    },
    // airboost-ctas-new.liquid:1843-1856, moved as-is (3 s after load).
    patchShadow: function () {
      var gokwikWidget = D.querySelector('gokwik-offer-widget-overlay');
      if (gokwikWidget && gokwikWidget.shadowRoot) {
        var style = D.createElement('style');
        style.textContent = '\n      .gokwik-offer-widget .truncate {\n        white-space: pre-wrap !important;\n      }\n    ';
        gokwikWidget.shadowRoot.appendChild(style);
      }
    }
  };

  /* ================================================================ Festive */
  var TPL_ROW = '[code]: Free [title] Worth MRP \u20b9[worth]';
  var CAP_H = 'YOUR FREE GIFT HAMPER \u00b7 TAP TO CHANGE';
  var CAP_O = 'YOUR FESTIVE OFFER \u00b7 TAP TO CHANGE';
  // "festive" without large/small/festive5 is inactive (a broken metafield never breaks the PDP).
  function festOf(d) {
    var f = d && d.festive, c = f && f.cfg;
    return c && typeof c === 'object' && (c.large || c.small || c.festive5) ? f : null;
  }
  function festInactive() { var t = +sget('dfx_festive_inactive2'); return t > 0 && Date.now() - t < INACTIVE_MS; }
  // C1-G7 / D-16: a Custom size is classed by the TYPED width; 0 = every Custom is Large.
  function customSmall(cfg, custom) {
    var mw = cfg.custom_small_max_width == null ? 36 : Number(cfg.custom_small_max_width) || 0;
    return !!custom && Number(custom.wid) <= mw;
  }
  function excluded(d, v) { return (festOf(d).cfg.exclude_variants || []).some(function (x) { return String(x) === String(v.id); }); }
  // 'none' = no festive offer for this variant (excluded, or a size outside the offer sheet: no coupon name on the
  // variant); 'custom' = a custom size: gift hamper only, never Festive5 (Mayank 2026-09-30); else its coupon name.
  function cls(d, v) {
    idx(d);
    if (!festOf(d) || !v || excluded(d, v)) return 'none';
    if (isCustV(d, v)) return 'custom';
    return v.h && v.h.c ? String(v.h.c) : 'none';
  }
  // The variant's OWN hamper (2026-09-30). Standard size: gifts = VARIANT custom.combo_offer_products, coupon name =
  // VARIANT custom.festive_offer (island v.h); title / worth / dropdown copy come from the product config record with
  // that coupon name. Custom size (one variant for every width): the config's small / large record by the typed width.
  // Unpublished gifts are dropped (F-8.1); no gift left = null.
  function hamperOf(d, v, custom) {
    var f = festOf(d);
    if (!f || !v || excluded(d, v)) return null;
    var ok = {}, key, code, src;
    (f.items || []).forEach(function (it) { ok[String(it.variant)] = it; });
    if (isCustV(d, v)) {
      key = customSmall(f.cfg, custom) ? 'small' : 'large';
      if (!f.cfg[key] || typeof f.cfg[key] !== 'object') return null;
      code = f.cfg[key].code;
      src = (f.cfg[key].items || []).map(function (it) { return { v: it.variant, q: it.qty }; });
    } else {
      if (!v.h) return null;
      code = v.h.c;
      src = v.h.i || [];
      key = ['large', 'small'].filter(function (k) { return f.cfg[k] && typeof f.cfg[k] === 'object' && norm(f.cfg[k].code) === norm(code); })[0];
    }
    var i = src.filter(function (x) { return +x.v && ok[String(x.v)]; }).map(function (x) { return { v: +x.v, q: +x.q || 1 }; });
    if (!i.length) return null;
    var r = key ? f.cfg[key] : {};
    var w = +r.worth || Math.round(i.reduce(function (s, x) { return s + x.q * (+ok[String(x.v)].compare_at || 0); }, 0) / 100);
    // gm = the gifts' MRP in paise, gu = gift units (each billed ₹1): what the cart % off counts, not the sheet worth.
    var gm = i.reduce(function (s, x) { return s + x.q * (+ok[String(x.v)].compare_at || 0); }, 0);
    var gu = i.reduce(function (s, x) { return s + x.q; }, 0);
    return { c: String(code || ''), t: String(r.title || 'Gift Hamper'), w: w, wt: (key && f.wt && f.wt[key]) || String(w).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      sh: String(r.short || ''), row: String(r.row || ''), i: i, gm: gm, gu: gu };
  }
  // Hamper of a Size value = that of its first variant that has one (the sheet gives every variant of a size the same).
  function sizeHamper(d, si, custom) { var h = null; d.variants.some(function (v) { return v.o[0] === si && !!(h = hamperOf(d, v, custom)); }); return h; }
  function anyHamper(d) { var h = null; d.variants.some(function (v) { return !isCustV(d, v) && !!(h = hamperOf(d, v, null)); }); return h; }
  // The shopper's CHOICE is kept; the EFFECTIVE offer follows the size (Single without a small
  // hamper -> Festive5 -> none) and the 30-min inactive flag of the cart guard (D-9.4).
  function effectiveOffer(d, choice, q, inactive) {
    var f = festOf(d);
    if (!f || inactive || q.cls === 'none') return 'none';
    if (choice === 'hamper' && q.h) return 'hamper';
    if ((choice === 'hamper' || choice === 'festive5') && f.cfg.festive5 && q.cls !== 'custom') return 'festive5';
    return 'none';
  }
  function fillRow(tpl, h) {
    return tpl.split('[code]').join(h.c).split('[title]').join(h.t).split('[worth]').join(h.wt).split('[short]').join(h.sh);
  }
  // The dropdown's hamper row: the offer sheet's copy (config record `row`) when there is one, else the block template.
  function rowText(tpl, h) { return h.row || fillRow(tpl, h); }
  var NA_TXT = 'Festive Offer is not available for this size';
  function choiceStore() { try { return JSON.parse(sget('dfx_festive_choice') || '{}') || {}; } catch (e) { return {}; } }
  var Festive = {
    block: function (inst) { return $('[data-dfx-festive][data-section="' + inst.sid + '"]') || (instances.size < 2 ? $('[data-dfx-festive]') : null); },
    // Default = the block's default_offer (effectiveOffer coerces it when not eligible), remembered
    // per product for the session (D-7).
    initChoice: function (inst) {
      var f = festOf(inst.d);
      if (!f) return null;
      var st = choiceStore()[inst.d.product && inst.d.product.handle];
      return st === 'hamper' || st === 'festive5' ? st : (f.defaultOffer || 'hamper');
    },
    // Festive.commit: the ONE writer for an offer change (block radios, popup Confirm via S6, qty).
    commit: function (inst, choice, from, silent) {
      if (!festOf(inst.d)) return;
      var st = choiceStore();
      if (inst.d.product && choice) { st[inst.d.product.handle] = choice; sset('dfx_festive_choice', JSON.stringify(st)); }
      var a = copy(inst.applied);
      a.offer = choice;
      Commit.apply(inst, a, { source: 'festive', from: from, silent: silent });
    },
    // The in-page block (D-9.1 markup): caption, selected label, rows, See My Hamper, notes.
    render: function (inst, q) {
      q = shown(q);
      var b = Festive.block(inst), f = festOf(inst.d);
      if (!b || !f) return;
      var inactive = festInactive(), hasH = !!q.h && !inactive, hasF = !!f.cfg.festive5 && !inactive && q.cls !== 'custom' && q.cls !== 'none';
      var lastRow = null;
      $$('input[data-dfx-offer]', b).forEach(function (i) {
        var row = i.closest('label') || i.parentNode;
        if (i.checked !== (i.value === q.offer)) i.checked = i.value === q.offer;
        // the chosen offer already shows in the dropdown head: the list only offers the alternatives
        var off = (i.value === 'hamper' && !hasH) || (i.value === 'festive5' && !hasF) || i.checked;
        hideEl(row, off);
        tog(row, 'is-last', false);
        if (!off) lastRow = row;
      });
      tog(lastRow, 'is-last', true);
      var hr = $('[data-dfx-offer-row="hamper"]', b);
      if (hr && q.h) setText(hr, rowText(hr.getAttribute('data-tpl') || TPL_ROW, q.h));
      // claim bar worth follows the selected size; the bar may be its own block (festive_claim), so look section-wide
      // text follows the offer picked: hamper -> data-tpl, Festive5 / none -> data-tpl-alt (Mayank 2026-09-30)
      $$('.dfx-fo__strip-t[data-tpl]', inst.pi || D).forEach(function (stt) { if (q.h) setText(stt, fillRow((q.offer !== 'hamper' && stt.getAttribute('data-tpl-alt')) || stt.getAttribute('data-tpl'), q.h)); });
      var cap = $('[data-dfx-offer-cap]', b);
      if (cap) setText(cap, q.offer === 'hamper' ? (cap.getAttribute('data-cap-hamper') || CAP_H) : (cap.getAttribute('data-cap-offer') || CAP_O));
      var chosen = $('input[data-dfx-offer][value="' + q.offer + '"]', b);
      if (inactive) setText($('[data-dfx-offer-sel]', b), 'Festive offers are temporarily unavailable');
      else if (q.cls === 'none') setText($('[data-dfx-offer-sel]', b), NA_TXT);
      else if (chosen) setText($('[data-dfx-offer-sel]', b), (chosen.closest('label') || chosen.parentNode).textContent.replace(/\s+/g, ' ').trim());
      // See My Hamper stays visible whatever offer is picked (Mayank 2026-09-30)
      var n = $('[data-dfx-fo-block-note]', b);
      if (inactive && !n) {
        n = D.createElement('small');
        n.className = 'dfx-fo__note';
        n.setAttribute('data-dfx-fo-block-note', '');
        ($('.dfx-fo__block', b) || b).appendChild(n);
      }
      if (n) { setText(n, inactive ? 'Festive offers are temporarily unavailable' : ''); hideEl(n, !inactive); }
    },
    // The popup: header chip, compact picker cards, Size sub-labels (all staged, preview only).
    mirror: function (inst, s, q) {
      q = shown(q);
      var d = inst.d, f = festOf(d), r = inst.root;
      if (!f) return;
      var inactive = festInactive(), hasH = !!q.h && !inactive;
      var chip = $('[data-dfx-hamper-chip]', r);
      if (chip) { hideEl(chip, !hasH); if (q.h) setText($('[data-dfx-chip-worth]', chip), '\u20b9' + q.h.wt); }
      var pick = $('[data-dfx-offer-picker]', r);
      if (pick) {
        var hc = $('[data-dfx-card="hamper"]', pick), fc = $('[data-dfx-card="festive5"]', pick);
        hideEl(hc, !hasH);
        hideEl(fc, !f.cfg.festive5 || inactive || q.cls === 'custom' || q.cls === 'none');
        $$('input[type="radio"]', pick).forEach(function (i) { if (i.checked !== (i.value === q.offer)) i.checked = i.value === q.offer; });
        if (hc && q.h) {
          setText($('[data-dfx-card-title]', hc), q.h.c + ' \u00b7 Free ' + q.h.t + ' \u00b7 Worth MRP \u20b9' + q.h.wt + ' \u00b7 ' + q.h.sh);
          setText($('[data-dfx-card-price]', hc), q.baseText);
          setText($('[data-dfx-card-chip]', hc), q.hp + '% off incl. hamper');
        }
        if (fc && q.v) { setText($('[data-dfx-card-price]', fc), q.f5Text); setText($('[data-dfx-card-chip]', fc), q.f5Pct + '% off'); }
      }
      var vs = vsOf(inst);
      if (!vs || !d.values[0]) return;
      d.values[0].forEach(function (x, xi) {
        var rd = ctrl(vs, x.id), lab = rd && rd.id && $('label[for="' + rd.id + '"]', vs), sub = lab && $('[data-dfx-sub]', lab);
        if (!sub) return;
        if (inactive) { tog(lab, 'dfx-has-hamper', false); return hideEl(sub, true); }
        var h = sizeHamper(d, xi, s.lw);
        tog(lab, 'dfx-has-hamper', !!h);   // gold "Gift hamper" line + wider chip (CSS)
        setText(sub, h ? 'Gift hamper \u20b9' + h.wt : 'Not in offer');
        hideEl(sub, false);
      });
    },
    onBlockChange: function (inst, input) {
      var b = Festive.block(inst), mode = (b && b.getAttribute('data-mode')) || (inst.d.festive || {}).blockMode;
      var opts = b && $('[data-dfx-offer-opts]', b), tg = b && $('[data-dfx-offer-toggle]', b);
      hideEl(opts, true);
      setAttr(tg, 'aria-expanded', 'false');
      if (mode === 'popup' && inst.d.mode === 'picker') {
        // D-6 alternative: the offer applies on the popup's Confirm, like the size (rule 3.3).
        Festive.render(inst, quoteOf(inst.d, inst.applied, qtyOf(inst)));
        Popup.open(inst, 'festive');
        if (inst.staged) { inst.staged.offer = input.value; Popup.preview(inst, inst.staged); }
        return;
      }
      Festive.commit(inst, input.value, 'block');
    },
    openHamper: function (inst, source) {
      var b = inst && Festive.block(inst), dlg = b ? $('[data-dfx-hamper]', b) : $('[data-dfx-hamper]');
      if (!dlg || !inst) return;
      var q = quoteOf(inst.d, inst.isOpen && inst.staged ? inst.staged : inst.applied, qtyOf(inst));
      var h = q.h || anyHamper(inst.d), c = h ? h.c : '';
      if (h) setText($('[data-dfx-hamper-title]', dlg), h.t);
      // The image of the coupon (a Files image named after it, data-imgs built by Liquid), else the product's image.
      var im = $('[data-dfx-hamper-img]', dlg);
      if (im) {
        var map = {};
        try { map = JSON.parse(im.getAttribute('data-imgs') || '{}') || {}; } catch (e) {}
        var own = (h && map[h.c]) || '', src = own || im.getAttribute('data-fallback') || '';
        if (src && im.getAttribute('src') !== src) im.setAttribute('src', src);
        if (own) { im.removeAttribute('width'); im.removeAttribute('height'); }
        tog(im, 'dfx-fo__photo--coupon', !!own);
        im.setAttribute('alt', own && h ? h.t : '');
        hideEl(im, !src);
      }
      $$('[data-dfx-hamper-items] li[data-size]', dlg).forEach(function (li) { hideEl(li, li.getAttribute('data-size') !== c); });
      lift(inst, true);
      dlg.hidden = false;
      void dlg.offsetWidth;
      dlg.classList.add('show');
      D.documentElement.classList.add('dfx-hamper-open');
      dlg.__dfxFocus = D.activeElement;
      var dl = $('[role="dialog"]', dlg);
      try { if (dl) dl.focus({ preventScroll: true }); } catch (e) {}
      Track(inst, 'hamper', { sid: inst.sid, code: h ? h.c : '', source: source });
    },
    closeHamper: function (dlg) {
      if (!dlg || !dlg.classList.contains('show')) return;
      dlg.classList.remove('show');
      dlg.hidden = true;
      D.documentElement.classList.remove('dfx-hamper-open');
      var hi = instFor(dlg);
      if (hi && !hi.isOpen) lift(hi, false);
      var lf = dlg.__dfxFocus;
      if (lf && lf.focus && D.contains(lf)) try { lf.focus({ preventScroll: true }); } catch (e) {}
    },
    // D-9.4 "Buy Now" (C2-B1, C3-N2/N4): hamper lines ONLY - dfxComboBuyNowItems builds items[0].
    buyNowItems: function (form, id, qty) {
      var pi = form && form.closest && form.closest('product-info'), inst = null;
      instances.forEach(function (i) { if (!inst && pi && i.pi === pi) inst = i; });
      if (!inst) inst = firstInst(function (i) { return i.d.mode === 'picker'; });
      if (!inst || !festOf(inst.d)) return null; // not festive-active: the caller keeps today's []
      var d = inst.d, f = festOf(d);
      var q = quoteOf(d, inst.applied, qty);
      if (q.offer !== 'hamper' || festInactive() || f.live === false) return [];
      var v = d.byId[String(id)] || q.v;
      if (!v) return [];
      var h = hamperOf(d, v, isCustV(d, v) ? inst.applied.lw : null), out = [];
      if (!h) return [];
      qty = Math.max(1, parseInt(qty) || 1);
      h.i.forEach(function (it) {
        out.push({ id: it.v, quantity: qty * it.q, properties: { _hamper_for: String(d.product.id), _festive_code: h.c, 'Free Gift': 'Free ' + h.t + ' Worth MRP \u20b9' + h.wt + ' \u00b7 Coupon ' + h.c } });
      });
      return out;
    }
  };

  /* ================================================================ Voucher */
  // D-9.7: the PDP ticker stops when the tab is hidden (hover/focus/reduced motion are CSS).
  var Voucher = {
    sync: function () {
      var p = D.hidden ? 'paused' : '';
      $$('[data-dfx-gv] .dfx-gv__track').forEach(function (t) { if (t.style.animationPlayState !== p) t.style.animationPlayState = p; });
    }
  };

  /* ================================================================ Track */
  // Window/document CustomEvents only (D-8.3). The GA4 names exist but stay OFF (D-9).
  var TRACK = {
    open: ['dfx:pdp-open', 'qlp_size_popup_open'], cancel: ['dfx:pdp-cancel', 'qlp_size_popup_cancel'],
    confirm: ['dfx:pdp-confirm', 'qlp_size_popup_confirm'], applied: ['dfx:pdp-applied'],
    landing_timeout: ['dfx:pdp-landing-timeout'], link_nav: ['dfx:pdp-link-nav'],
    festive: ['dfx:festive-offer', 'qlp_festive_offer_select'], hamper: ['dfx:hamper-open', 'qlp_festive_hamper_view']
  };
  function Track(inst, name, detail) {
    var t = TRACK[name];
    emit(t[0], detail);
    if (t[1] && inst && inst.d.flags.ga4 && typeof W.DFXThemeTrack === 'function') try { W.DFXThemeTrack(t[1], detail); } catch (e) {}
  }

  /* ================================================================ Page */
  function firstInst(pred) {
    var hit = null;
    instances.forEach(function (i) { if (!hit && !i.dead && pred(i)) hit = i; });
    return hit;
  }
  function instFor(el) {
    var pi = el && el.closest && el.closest('product-info'), hit = null;
    if (pi) instances.forEach(function (i) { if (!hit && i.pi === pi) hit = i; });
    return hit;
  }
  function getInst(sid) { return sid ? instances.get(sid) : firstInst(function (i) { return i.d.mode === 'picker'; }) || firstInst(function () { return true; }); }
  // [data-dfx-open]: the root of the trigger's product-info, else the first picker root;
  // 'color' needs a root with link groups.
  function pickInst(el, kind) {
    var i = instFor(el);
    if (kind === 'color' && (!i || !i.d.links.length)) i = firstInst(function (x) { return x.d.links.length > 0; });
    return i || firstInst(function (x) { return x.d.mode === 'picker'; });
  }

  function Instance(root, d, pi) {
    var inst = this;
    inst.root = root; inst.d = d; inst.pi = pi; inst.sid = root.getAttribute('data-section') || d.sid;
    inst.isOpen = false; inst.userTouched = false; inst.landing = null; inst.staged = null;
    // P-13 staging: quick-add -> inline; a non-button picker -> passthrough; else popup (apply on Confirm).
    // Phase B: there is no theme-settings kill switch any more.
    inst.staging = pi && pi.dataset.originalSection ? 'inline' :
      (root.getAttribute('data-picker') || 'button') !== 'button' ? 'passthrough' : 'popup';
    root.setAttribute('data-dfx-staging', inst.staging);
    if (inst.staging === 'inline') root.hidden = false;
    inst.sc = inst.staging === 'inline' ? pi : D; // a quick-add never writes the main product's forms
    var v = d.byId[String(d.selected)] || d.variants[0];
    inst.applied = { vid: v ? String(v.id) : '', o: v ? v.o.slice() : [], lw: readLW(inst), offer: Festive.initChoice(inst), inC: isCustV(d, v), dimSave: null };
    inst.onChange = function (e) { Popup.onChange(inst, e); };
    inst.onClick = function (e) { Popup.onClick(inst, e); };
    inst.onKey = function (e) { Popup.onKey(inst, e); };
    root.addEventListener('change', inst.onChange, true);
    root.addEventListener('click', inst.onClick);
    root.addEventListener('keydown', inst.onKey);
    root.__dfxPdp = inst;
    instances.set(inst.sid, inst);
    // D-1.2.3 / D-7.9: the landing state is made consistent synchronously (price, labels, 7 custom
    // properties, GoKwik) before memory runs - no 400 ms timer.
    Commit.apply(inst, copy(inst.applied), { source: 'boot' });
    // a landing on the Custom variant with a standard size in the L x W inputs moves to that standard variant
    if (inst.staging === 'popup' && stdSel(inst.d, inst.applied) !== inst.applied) Commit.apply(inst, copy(inst.applied), { source: 'memory' });
    Memory.run(inst);
  }
  Instance.prototype.open = function (trigger) { Popup.open(this, trigger || 'api'); };
  Instance.prototype.cancel = function (via) { Popup.cancel(this, via || 'api'); };
  Instance.prototype.confirm = function () { Popup.confirm(this); };
  Instance.prototype.stage = function (p) {
    if (!this.isOpen) this.open('api');
    var s = this.staged, d = this.d;
    if (!s || !p) return;
    if (p.vid != null && d.byId[String(p.vid)]) s.o = d.byId[String(p.vid)].o.slice();
    if (p.o) s.o = p.o.slice();
    if (p.lw) s.lw = { len: parseInt(p.lw.len) || 72, wid: parseInt(p.lw.wid) || 30 };
    if (p.offer) s.offer = p.offer;
    if (has(p, 'link')) s.link = p.link;
    Popup.restage(this);
  };
  Instance.prototype.state = function () {
    return copy({ applied: this.applied, staged: this.staged, phase: this.isOpen ? 'open' : this.landing ? 'landing' : 'closed', cartId: cartId(this), staging: this.staging });
  };
  Instance.prototype.destroy = function () {
    Popup.close(this, { noHistory: true });
    clearTimeout(this.watchT); clearTimeout(this.hideT); clearTimeout(this.popT);
    this.root.removeEventListener('change', this.onChange, true);
    this.root.removeEventListener('click', this.onClick);
    this.root.removeEventListener('keydown', this.onKey);
    this.dead = true;
    this.root.__dfxPdp = null;
    if (instances.get(this.sid) === this) instances.delete(this.sid);
  };

  function ownStamp() { var m = /[?&]v=([^&#]*)/.exec(SRC); return m ? m[1] : ''; }
  function boot(root) {
    if (root.__dfxPdp || root.getAttribute('data-dfx-pdp-state') === 'mismatch') return;
    var sid = root.getAttribute('data-section') || '';
    // P-12: a CDN-stale script next to fresh markup is reported, never acted on.
    var fp = root.getAttribute('data-dfx-pdp-js') || '', own = ownStamp();
    if (own && fp && fp.indexOf('/') < 0 && fp !== own) {
      warn('asset fingerprint mismatch', fp + ' != ' + own);
      emit('dfx:pdp-asset-mismatch', { sid: sid, root: fp, script: own, version: VERSION });
    }
    var el = Island.el(root, sid), d = el && Island.read(el);
    if (!Island.ok(d)) {
      // J2-M6: no bind at all - the PDP stays plain Dawn (degraded, never the deleted legacy path).
      warn('island v mismatch');
      emit('dfx:pdp-island-mismatch', { sid: sid, v: d ? d.v : null });
      root.setAttribute('data-dfx-pdp-state', 'mismatch');
      return;
    }
    var pi = root.closest('product-info');
    try {
      new Instance(root, idx(d), pi); // the boot apply stamps the default _festive (J1-9)
      root.setAttribute('data-dfx-pdp-state', 'ready');
    } catch (e) { warn('boot', e); }
  }
  function bootAll(scope) {
    scope = scope || D;
    var roots = $$('[data-dfx-pdp]', scope);
    if (scope.matches && scope.matches('[data-dfx-pdp]')) roots.unshift(scope);
    roots.forEach(boot);
  }

  // J1-1: today's window.productVariants survives as a counting getter while the GTM audit runs.
  function legacyGetter() {
    var el = $('script[id^="dfx-pdp-data-"]');
    if (!el) return;
    var cache = null, sent = false;
    try {
      Object.defineProperty(W, 'productVariants', {
        configurable: true,
        get: function () {
          W.__dfxLegacyReads = (W.__dfxLegacyReads || 0) + 1;
          if (!sent) { sent = true; emit('dfx:pdp-legacy-global-read', { count: W.__dfxLegacyReads }); }
          if (!cache) {
            var i = firstInst(function () { return true; }), d = i ? i.d : Island.read(el);
            cache = Island.ok(d) ? Island.legacy(d) : [];
          }
          return cache;
        }
      });
    } catch (e) {}
  }

  // One set of document/window listeners for every root.
  D.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var o = t.closest('[data-dfx-open]');
    if (o) {
      var i = pickInst(o, o.getAttribute('data-dfx-open'));
      if (i) { e.preventDefault(); Popup.open(i, o.getAttribute('data-dfx-open')); }
      return;
    }
    var h = t.closest('[data-dfx-hamper-open]');
    if (h) return Festive.openHamper(instFor(h) || firstInst(function (x) { return !!festOf(x.d); }), h.getAttribute('data-dfx-hamper-open'));
    var hc = t.closest('[data-dfx-hamper-close]');
    if (hc) return Festive.closeHamper(hc.closest('[data-dfx-hamper]'));
    var tg = t.closest('[data-dfx-offer-toggle]');
    if (tg) {
      var fb = tg.closest('[data-dfx-festive]'), opts = fb && $('[data-dfx-offer-opts]', fb);
      if (opts) { hideEl(opts, !opts.hidden); tg.setAttribute('aria-expanded', opts.hidden ? 'false' : 'true'); }
      return;
    }
    if (t.closest('.quantity__button')) Sticky.writeQty(); // theme.liquid:1876-1879
  });
  D.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.name === 'id' && t.closest('form[action*="/cart/add"]')) {
      var val = String(t.value);
      instances.forEach(function (i) {
        if (val !== '' && !i.d.byId[val]) return;
        if (val === '' && !(i.pi && i.pi.contains(t))) return;
        if (!e.__dfxApply && i.landing) {
          if (val === '') Commit.unavailable(i);             // R7 (also when '' was requested)
          else if (val === i.landing.vid) Commit.landed(i); // R1
        }
        if (val !== '' && !e.__dfxApply) Sticky.mirrorNav(i, val, !i.d.byId[val].a); // R6
        Labels.syncFromCart(i);
      });
      return;
    }
    if ((t.id === 'custom_variant_select' || t.id === 'custom_mobile_selected_variant') && e.isTrusted) {
      // Keyboard / assistive-tech bridge (deployed L153-163): the display selects commit.
      var k = firstInst(function (x) { return !!x.d.byId[String(t.value)]; });
      if (!k) return;
      k.userTouched = true;
      Memory.userTouch(k);
      var sel = copy(k.applied);
      sel.o = k.d.byId[String(t.value)].o.slice();
      sel.inC = isCustV(k.d, k.d.byId[String(t.value)]);
      Commit.apply(k, sel, { source: 'keyboard' });
      return;
    }
    if (t.matches && t.matches('.quantity__input')) { onQty(instFor(t)); Sticky.writeQty(); return; }
    if (t.matches && t.matches('input[data-dfx-offer]')) {
      var fb = t.closest('[data-dfx-festive]'), sid = fb && fb.getAttribute('data-section');
      var fi = (sid && instances.get(sid)) || firstInst(function (x) { return !!festOf(x.d); });
      if (fi) Festive.onBlockChange(fi, t);
    }
  }, true);
  // R5: quantity changes re-quote the festive offer and move the GoKwik amount.
  function onQty(inst) {
    var list = inst ? [inst] : [];
    if (!inst) instances.forEach(function (i) { list.push(i); });
    list.forEach(function (i) {
      if (i.dead || i.d.mode === 'links') return;
      if (festOf(i.d)) Festive.commit(i, i.applied.offer, 'qty', true);
      else { var q = quoteOf(i.d, i.applied, qtyOf(i)); Commit.writePrice(i, q); Gokwik.push(i, q); }
    });
  }
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var dlg = $('.dfx-hamper.show');
    if (dlg) return Festive.closeHamper(dlg); // the hamper dialog closes first, then the popup
    instances.forEach(function (i) { if (i.isOpen) Popup.cancel(i, 'escape'); });
  });
  D.addEventListener('submit', function (e) {
    instances.forEach(function (i) { if (i.isOpen && (!i.pi || i.pi.contains(e.target) || e.target.id === 'product-form-' + i.sid)) Popup.cancel(i, 'submit'); });
  });
  D.addEventListener('shopify:section:load', function (e) { bootAll(e.target); });
  D.addEventListener('shopify:section:unload', function (e) {
    instances.forEach(function (i) { if (e.target && e.target.contains && e.target.contains(i.root)) i.destroy(); });
  });
  D.addEventListener('product-info:loaded', function (e) { bootAll(e.target); });
  D.addEventListener('shopify:block:select', function (e) {
    var b = e.target, fb = b && (b.matches && b.matches('[data-dfx-festive]') ? b : b.querySelector && b.querySelector('[data-dfx-festive]'));
    var opts = fb && $('[data-dfx-offer-opts]', fb);
    if (opts) { opts.hidden = false; setAttr($('[data-dfx-offer-toggle]', fb), 'aria-expanded', 'true'); }
  });
  D.addEventListener('visibilitychange', Voucher.sync);
  W.addEventListener('popstate', function () {
    instances.forEach(function (i) {
      if (i.popPending) {
        // The popstate of OUR history.back(): link navigation, or R0 when Dawn's render landed first.
        i.popPending = false;
        clearTimeout(i.popT);
        if (i.nav) { var u = i.nav; i.nav = null; return W.location.assign(u); }
        if (i.landedEarly && i.pi && i.applied.vid && i.pi.updateURL) try { i.pi.updateURL(i.pi.dataset.url, i.applied.vid); } catch (e) {}
        i.landedEarly = false;
        return;
      }
      if (i.isOpen && i.token && !(W.history.state && W.history.state.dfxPdp === i.token)) Popup.cancel(i, 'back', true);
    });
  });
  W.addEventListener('pageshow', function (e) {
    instances.forEach(function (i) {
      if (e.persisted && i.isOpen) Popup.cancel(i, 'pageshow', true);
      Labels.syncFromCart(i);
      if (e.persisted && festOf(i.d)) Festive.commit(i, i.applied.offer, 'pageshow', true);
    });
  });
  W.addEventListener('pagehide', function () {
    instances.forEach(function (i) { if (i.isOpen) Popup.cancel(i, 'pagehide', true); });
  });
  W.addEventListener('gokwikLoaded', function () {
    instances.forEach(function (i) { if (i.d.mode === 'picker') Gokwik.push(i, quoteOf(i.d, i.applied, qtyOf(i))); });
  });
  // constants.js declares PUB_SUB_EVENTS as a global lexical const: reachable by name, not on window.
  var PSE = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
  if (typeof subscribe === 'function' && PSE) {
    if (PSE.variantChange) {
      subscribe(PSE.variantChange, function (ev) {
        var data = ev && ev.data;
        if (!data) return;
        instances.forEach(function (i) {
          var key = i.pi ? (i.pi.dataset.originalSection || i.pi.dataset.section) : i.sid;
          if (data.sectionId === key || data.sectionId === i.sid) Commit.onVariantChange(i, data);
        });
      });
    }
    if (PSE.quantityUpdate) subscribe(PSE.quantityUpdate, function () { onQty(null); });
  }

  // Legacy names still called from inline markup (U-3.3) and from dfx-combo-offer (C2-B1).
  W.showBottomSheet = function () { W.DfxPdp.open('sticky'); };
  W.airboostMobStickyAtc = function (e, btn) { Sticky.proxyAtc(e, btn); };
  W.dfxFestiveBuyNowItems = function (form, id, qty) {
    try { return Festive.buyNowItems(form, id, qty); } catch (e) { return null; }
  };
  W.DfxPdp = Object.freeze({
    version: VERSION,
    instances: instances,
    open: function (trigger, sid) { var i = getInst(sid); if (i) i.open(trigger || 'api'); },
    close: function (sid) { var i = getInst(sid); if (i) i.cancel('api'); },
    confirm: function (sid) { var i = getInst(sid); if (i) i.confirm(); },
    state: function (sid) { var i = getInst(sid); return i ? i.state() : null; },
    quote: function (selection, sid) {
      var i = getInst(sid);
      if (!i) return null;
      var s = copy(selection || i.applied);
      if (s.vid != null && !s.o && i.d.byId[String(s.vid)]) s.o = i.d.byId[String(s.vid)].o.slice();
      return quoteOf(i.d, s, s.qty || qtyOf(i));
    },
    __pure: Object.freeze({ settle: settle, available: available, exact: exact, customQuote: customQuote, quoteOf: quoteOf, off5: off5, cls: cls, hamperOf: hamperOf, rupees: convert_rupees, stdSel: stdSel, dealQty: dealQty, linkView: linkView, linkResolve: linkResolve, linkOpen: linkOpen, linkQuote: linkQuote, moneyLike: moneyLike })
  });

  function start() {
    // deployed L32-37: the legacy auto-select cookie is retired on every PDP view.
    try { if (/(?:^|;\s*)selected_variant=/.test(D.cookie)) D.cookie = 'selected_variant=; path=/; max-age=0'; } catch (e) {}
    Sticky.initPage();
    setTimeout(Gokwik.patchShadow, 3000);
    bootAll(D);
    legacyGetter();
    Voucher.sync();
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
})();
